var _defs, _g, _path, _g2, _path2, _g3, _g4, _g5, _g6, _path3, _path4, _g7, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128.55pt",
    height: "176.25pt",
    viewBox: "0 0 128.55 176.25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6719 0v-0.89062h-1.6094v-0.40625l1.6875-2.3906h0.375v2.3906h0.5v0.40625h-0.5v0.89062zm0-1.2969v-1.6719l-1.1562 1.6719z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5938-0.4375v0.4375h-2.4375c0-0.10156 0.015625-0.20703 0.046875-0.3125 0.0625-0.16406 0.16016-0.32812 0.29688-0.48438 0.14453-0.16406 0.34375-0.35156 0.59375-0.5625 0.40625-0.33203 0.67578-0.59375 0.8125-0.78125 0.14453-0.19531 0.21875-0.37891 0.21875-0.54688 0-0.17578-0.070312-0.32812-0.20312-0.45312-0.125-0.125-0.28906-0.1875-0.48438-0.1875-0.21875 0-0.39844 0.070313-0.53125 0.20312-0.13672 0.125-0.20312 0.30469-0.20312 0.53125l-0.46875-0.046875c0.039063-0.34375 0.16016-0.60156 0.35938-0.78125 0.20703-0.1875 0.48828-0.28125 0.84375-0.28125 0.35156 0 0.63281 0.10156 0.84375 0.29688 0.20703 0.19922 0.3125 0.4375 0.3125 0.71875 0 0.15625-0.03125 0.30859-0.09375 0.45312-0.0625 0.13672-0.16797 0.28125-0.3125 0.4375-0.13672 0.15625-0.36719 0.375-0.6875 0.65625-0.27344 0.23047-0.44922 0.38672-0.53125 0.46875-0.074219 0.074219-0.13672 0.15234-0.1875 0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.28125-0.85938 0.4375-0.03125c0.03125 0.19922 0.097656 0.34375 0.20312 0.4375 0.10156 0.09375 0.23828 0.14062 0.40625 0.14062 0.13281 0 0.25391-0.03125 0.35938-0.09375 0.11328-0.0625 0.20312-0.14453 0.26562-0.25 0.0625-0.11328 0.11328-0.25781 0.15625-0.4375 0.050781-0.17578 0.078125-0.35938 0.078125-0.54688v-0.09375c-0.09375 0.14844-0.21875 0.26562-0.375 0.35938-0.15625 0.085938-0.32422 0.125-0.5 0.125-0.3125 0-0.57422-0.10938-0.78125-0.32812-0.21094-0.22656-0.3125-0.51953-0.3125-0.875 0-0.375 0.10938-0.67578 0.32812-0.90625 0.21875-0.22656 0.49219-0.34375 0.82812-0.34375 0.23828 0 0.45703 0.070313 0.65625 0.20312 0.19531 0.125 0.34766 0.30859 0.45312 0.54688 0.10156 0.24219 0.15625 0.58594 0.15625 1.0312 0 0.46875-0.054687 0.84375-0.15625 1.125-0.10547 0.28125-0.25781 0.49609-0.45312 0.64062-0.19922 0.14844-0.4375 0.21875-0.71875 0.21875s-0.51562-0.078125-0.70312-0.23438c-0.17969-0.16406-0.28906-0.39453-0.32812-0.6875zm1.8594-1.625c0-0.25781-0.074219-0.46094-0.21875-0.60938-0.13672-0.15625-0.29688-0.23438-0.48438-0.23438-0.21094 0-0.38672 0.085937-0.53125 0.25-0.14844 0.15625-0.21875 0.37109-0.21875 0.64062 0 0.23047 0.066406 0.41797 0.20312 0.5625 0.14453 0.14844 0.32031 0.21875 0.53125 0.21875 0.20703 0 0.37891-0.070312 0.51562-0.21875 0.13281-0.14453 0.20312-0.34766 0.20312-0.60938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.90625-2c-0.1875-0.070312-0.32812-0.17188-0.42188-0.29688-0.085937-0.125-0.125-0.27344-0.125-0.45312 0-0.26953 0.09375-0.49219 0.28125-0.67188 0.19531-0.1875 0.45703-0.28125 0.78125-0.28125 0.32031 0 0.57812 0.09375 0.76562 0.28125 0.19531 0.1875 0.29688 0.41797 0.29688 0.6875 0 0.16797-0.046875 0.3125-0.14062 0.4375-0.085938 0.125-0.21484 0.22656-0.39062 0.29688 0.21875 0.074219 0.38281 0.19531 0.5 0.35938 0.125 0.16797 0.1875 0.35938 0.1875 0.57812 0 0.32422-0.11719 0.59375-0.34375 0.8125-0.21875 0.21094-0.51172 0.3125-0.875 0.3125-0.36719 0-0.66406-0.10156-0.89062-0.3125-0.21875-0.21875-0.32812-0.48828-0.32812-0.8125 0-0.23828 0.0625-0.4375 0.1875-0.59375 0.125-0.16406 0.29688-0.28125 0.51562-0.34375zm-0.078125-0.76562c0 0.17969 0.050781 0.32422 0.15625 0.4375 0.11328 0.10547 0.25781 0.15625 0.4375 0.15625 0.17578 0 0.32031-0.050781 0.4375-0.15625 0.11328-0.11328 0.17188-0.25391 0.17188-0.42188 0-0.16406-0.0625-0.30078-0.1875-0.40625-0.11719-0.11328-0.25781-0.17188-0.42188-0.17188-0.17969 0-0.32422 0.058594-0.4375 0.17188-0.10547 0.10547-0.15625 0.23438-0.15625 0.39062zm-0.15625 1.7031c0 0.125 0.03125 0.25 0.09375 0.375 0.0625 0.11719 0.14844 0.21094 0.26562 0.28125 0.125 0.0625 0.25781 0.09375 0.40625 0.09375 0.20703 0 0.37891-0.066406 0.51562-0.20312 0.14453-0.14453 0.21875-0.32031 0.21875-0.53125 0-0.21875-0.074219-0.39844-0.21875-0.54688-0.13672-0.14453-0.3125-0.21875-0.53125-0.21875s-0.40234 0.074219-0.54688 0.21875c-0.13672 0.14844-0.20312 0.32422-0.20312 0.53125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.25-3.2031v-0.4375h2.3906v0.34375c-0.24219 0.25-0.47656 0.58594-0.70312 1-0.23047 0.41797-0.40625 0.84375-0.53125 1.2812-0.09375 0.3125-0.15625 0.65234-0.1875 1.0156h-0.45312c0-0.28906 0.050781-0.64062 0.15625-1.0469 0.11328-0.41406 0.26953-0.8125 0.46875-1.1875 0.20703-0.38281 0.42578-0.70703 0.65625-0.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5625-2.7812-0.45312 0.03125c-0.042969-0.17578-0.10156-0.30469-0.17188-0.39062-0.11719-0.125-0.26562-0.1875-0.45312-0.1875-0.13672 0-0.26172 0.039063-0.375 0.10938-0.14844 0.10547-0.26172 0.26172-0.34375 0.46875-0.074219 0.19922-0.11719 0.48047-0.125 0.84375 0.11328-0.16406 0.25-0.28516 0.40625-0.35938 0.15625-0.082031 0.32031-0.125 0.5-0.125 0.30078 0 0.55469 0.10938 0.76562 0.32812 0.20703 0.21875 0.3125 0.50781 0.3125 0.85938 0 0.24219-0.054688 0.46094-0.15625 0.65625-0.09375 0.19922-0.23047 0.35156-0.40625 0.45312-0.16797 0.10156-0.36719 0.15625-0.59375 0.15625-0.375 0-0.68359-0.13281-0.92188-0.40625-0.24219-0.28125-0.35938-0.74219-0.35938-1.3906 0-0.70703 0.13281-1.2227 0.40625-1.5469 0.22656-0.28125 0.53516-0.42188 0.92188-0.42188 0.28906 0 0.53125 0.085937 0.71875 0.25 0.1875 0.15625 0.29688 0.38281 0.32812 0.67188zm-1.8438 1.5781c0 0.15625 0.03125 0.30859 0.09375 0.45312 0.0625 0.14844 0.14844 0.25781 0.26562 0.32812 0.125 0.074219 0.25391 0.10938 0.39062 0.10938 0.1875 0 0.34766-0.070312 0.48438-0.21875 0.14453-0.15625 0.21875-0.36719 0.21875-0.64062 0-0.25-0.070313-0.44531-0.20312-0.59375-0.13672-0.15625-0.30859-0.23438-0.51562-0.23438-0.21094 0-0.38672 0.078125-0.53125 0.23438-0.13672 0.14844-0.20312 0.33594-0.20312 0.5625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.21875-1.8125c0-0.4375 0.039062-0.78516 0.125-1.0469 0.09375-0.26953 0.22656-0.47656 0.40625-0.625 0.17578-0.14453 0.39844-0.21875 0.67188-0.21875 0.19531 0 0.36719 0.042969 0.51562 0.125 0.14453 0.074219 0.26562 0.1875 0.35938 0.34375 0.10156 0.14844 0.17969 0.32812 0.23438 0.54688 0.0625 0.21094 0.09375 0.5 0.09375 0.875 0 0.42969-0.046875 0.77734-0.14062 1.0469-0.085937 0.26172-0.21484 0.46484-0.39062 0.60938-0.17969 0.14844-0.40234 0.21875-0.67188 0.21875-0.35547 0-0.63672-0.125-0.84375-0.375-0.24219-0.3125-0.35938-0.8125-0.35938-1.5zm0.46875 0c0 0.60547 0.066406 1.0078 0.20312 1.2031 0.14453 0.19922 0.32031 0.29688 0.53125 0.29688 0.20703 0 0.37891-0.097656 0.51562-0.29688 0.14453-0.19531 0.21875-0.59766 0.21875-1.2031 0-0.61328-0.074219-1.0195-0.21875-1.2188-0.13672-0.19531-0.3125-0.29688-0.53125-0.29688-0.21094 0-0.375 0.089844-0.5 0.26562-0.14844 0.21875-0.21875 0.63672-0.21875 1.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.21875-0.96875 0.46875-0.03125c0.039062 0.23047 0.125 0.40234 0.25 0.51562 0.125 0.11719 0.28125 0.17188 0.46875 0.17188 0.21875 0 0.39844-0.078125 0.54688-0.23438 0.15625-0.16406 0.23438-0.39062 0.23438-0.67188 0-0.25-0.074219-0.44531-0.21875-0.59375-0.14844-0.15625-0.33984-0.23438-0.57812-0.23438-0.14844 0-0.27734 0.039063-0.39062 0.10938-0.11719 0.0625-0.21094 0.14844-0.28125 0.25l-0.42188-0.0625 0.35938-1.8906h1.8281v0.4375h-1.4688l-0.20312 0.98438c0.21875-0.15625 0.45312-0.23438 0.70312-0.23438 0.32031 0 0.59375 0.11719 0.8125 0.34375 0.21875 0.21875 0.32812 0.50781 0.32812 0.85938 0 0.33594-0.09375 0.62109-0.28125 0.85938-0.24219 0.30469-0.5625 0.45312-0.96875 0.45312-0.34375 0-0.62109-0.09375-0.82812-0.28125-0.21094-0.1875-0.32812-0.4375-0.35938-0.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.57812 0v-5.7344h4.25v0.96875h-3.0938v1.2812h2.875v0.95312h-2.875v1.5625h3.2031v0.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.57812-5.7344h1.1562v3.1094c0 0.49219 0.015625 0.80859 0.046875 0.95312 0.039062 0.24219 0.15625 0.43359 0.34375 0.57812 0.1875 0.13672 0.44141 0.20312 0.76562 0.20312 0.33203 0 0.58203-0.066406 0.75-0.20312 0.16406-0.13281 0.26562-0.29688 0.29688-0.48438 0.03125-0.19531 0.046875-0.52344 0.046875-0.98438v-3.1719h1.1562v3.0156c0 0.6875-0.03125 1.1719-0.09375 1.4531s-0.17969 0.52344-0.34375 0.71875c-0.16797 0.19922-0.39062 0.35547-0.67188 0.46875-0.28125 0.11328-0.65234 0.17188-1.1094 0.17188-0.54297 0-0.95312-0.0625-1.2344-0.1875s-0.50781-0.28516-0.67188-0.48438c-0.16797-0.20703-0.27734-0.42188-0.32812-0.64062-0.074219-0.33203-0.10938-0.81641-0.10938-1.4531z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.59375 0v-5.7344h2.4219c0.61328 0 1.0547 0.054687 1.3281 0.15625 0.28125 0.10547 0.50391 0.29297 0.67188 0.5625 0.16406 0.26172 0.25 0.55859 0.25 0.89062 0 0.42969-0.125 0.78125-0.375 1.0625s-0.625 0.46094-1.125 0.53125c0.25 0.14844 0.45312 0.30859 0.60938 0.48438 0.16406 0.17969 0.38281 0.48438 0.65625 0.92188l0.70312 1.125h-1.375l-0.84375-1.25c-0.29297-0.44531-0.49609-0.72656-0.60938-0.84375-0.10547-0.11328-0.21875-0.19141-0.34375-0.23438-0.125-0.039063-0.32031-0.0625-0.57812-0.0625h-0.23438v2.3906zm1.1562-3.3125h0.84375c0.5625 0 0.91016-0.019531 1.0469-0.0625 0.13281-0.050781 0.23828-0.13281 0.3125-0.25 0.082031-0.11328 0.125-0.25391 0.125-0.42188 0-0.19531-0.054687-0.35156-0.15625-0.46875-0.10547-0.11328-0.25-0.1875-0.4375-0.21875-0.09375-0.019531-0.375-0.03125-0.84375-0.03125h-0.89062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-2-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.0469-1.1875v1.1875h-6.625c-0.011719-0.28906 0.035156-0.57812 0.14062-0.85938 0.17578-0.44531 0.44531-0.89062 0.8125-1.3281 0.375-0.4375 0.91016-0.94141 1.6094-1.5156 1.0938-0.89453 1.8281-1.6016 2.2031-2.125 0.38281-0.51953 0.57812-1.0156 0.57812-1.4844 0-0.48828-0.17969-0.89844-0.53125-1.2344-0.34375-0.33203-0.79297-0.5-1.3438-0.5-0.59375 0-1.0742 0.17969-1.4375 0.53125-0.35547 0.35547-0.53125 0.85156-0.53125 1.4844l-1.2656-0.14062c0.082031-0.9375 0.40625-1.6484 0.96875-2.1406 0.57031-0.5 1.332-0.75 2.2812-0.75 0.96875 0 1.7266 0.26562 2.2812 0.79688 0.5625 0.53125 0.84375 1.1953 0.84375 1.9844 0 0.40625-0.085938 0.80469-0.25 1.1875-0.15625 0.38672-0.42969 0.79297-0.8125 1.2188-0.375 0.42969-1.0078 1.0156-1.8906 1.7656-0.74219 0.61719-1.2148 1.0391-1.4219 1.2656-0.21094 0.21875-0.38281 0.4375-0.51562 0.65625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-3-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.4375-1.3281 0.67188-0.0625c0.0625 0.32422 0.17188 0.55859 0.32812 0.70312 0.16406 0.13672 0.375 0.20312 0.625 0.20312 0.21875 0 0.40625-0.046875 0.5625-0.14062 0.16406-0.10156 0.30078-0.23828 0.40625-0.40625 0.10156-0.16406 0.19141-0.39062 0.26562-0.67188 0.070313-0.28125 0.10938-0.56641 0.10938-0.85938 0-0.03125-0.00781-0.078125-0.015625-0.14062-0.13672 0.23047-0.32812 0.41797-0.57812 0.5625-0.24219 0.13672-0.5 0.20312-0.78125 0.20312-0.48047 0-0.88672-0.17188-1.2188-0.51562-0.32422-0.34375-0.48438-0.79688-0.48438-1.3594 0-0.58203 0.17188-1.0508 0.51562-1.4062 0.34375-0.35156 0.77344-0.53125 1.2969-0.53125 0.36328 0 0.70312 0.10156 1.0156 0.29688 0.3125 0.19922 0.54688 0.48438 0.70312 0.85938s0.23438 0.91406 0.23438 1.6094c0 0.73047-0.078125 1.3125-0.23438 1.75s-0.39062 0.77344-0.70312 1c-0.3125 0.21875-0.68359 0.32812-1.1094 0.32812-0.44922 0-0.8125-0.125-1.0938-0.375s-0.45312-0.59766-0.51562-1.0469zm2.875-2.5312c0-0.39453-0.10938-0.71094-0.32812-0.95312-0.21094-0.23828-0.46484-0.35938-0.76562-0.35938-0.3125 0-0.58594 0.13281-0.8125 0.39062-0.23047 0.25-0.34375 0.57812-0.34375 0.98438 0 0.36719 0.10938 0.66406 0.32812 0.89062 0.21875 0.23047 0.48828 0.34375 0.8125 0.34375 0.32031 0 0.58594-0.11328 0.79688-0.34375 0.20703-0.22656 0.3125-0.54688 0.3125-0.95312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0469-0.96875c-0.0625 0.34375-0.17188 0.60156-0.32812 0.76562-0.15625 0.16797-0.34375 0.25-0.5625 0.25-0.34375 0-0.60156-0.15625-0.76562-0.46875-0.15625-0.3125-0.23438-0.6875-0.23438-1.125 0-0.48828 0.09375-0.86719 0.28125-1.1406 0.1875-0.28125 0.42969-0.42188 0.73438-0.42188 0.20703 0 0.38281 0.078125 0.53125 0.23438 0.14453 0.14844 0.25 0.36719 0.3125 0.65625l-0.28125 0.09375c-0.042969-0.21875-0.11719-0.37891-0.21875-0.48438-0.09375-0.10156-0.21484-0.15625-0.35938-0.15625-0.23047 0-0.40625 0.10938-0.53125 0.32812-0.11719 0.21875-0.17188 0.51172-0.17188 0.875 0 0.42969 0.0625 0.74609 0.1875 0.95312 0.125 0.21094 0.28906 0.3125 0.5 0.3125 0.16406 0 0.30078-0.0625 0.40625-0.1875 0.10156-0.13281 0.17578-0.33203 0.21875-0.59375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.1719-3.1094c0.30078 0 0.54688 0.14844 0.73438 0.4375 0.19531 0.28125 0.29688 0.66406 0.29688 1.1406 0 0.48047-0.10156 0.86719-0.29688 1.1562-0.1875 0.28125-0.43359 0.42188-0.73438 0.42188-0.3125 0-0.5625-0.14453-0.75-0.4375-0.1875-0.30078-0.28125-0.67188-0.28125-1.1094 0-0.5 0.09375-0.89062 0.28125-1.1719 0.19531-0.28906 0.44531-0.4375 0.75-0.4375zm0 2.8125c0.21875 0 0.39453-0.10938 0.53125-0.32812 0.13281-0.21875 0.20312-0.51953 0.20312-0.90625 0-0.39453-0.074219-0.69531-0.21875-0.90625-0.13672-0.21875-0.30859-0.32812-0.51562-0.32812-0.21875 0-0.39844 0.10547-0.53125 0.3125-0.13672 0.21094-0.20312 0.53125-0.20312 0.96875 0 0.35547 0.066406 0.64062 0.20312 0.85938 0.13281 0.21875 0.3125 0.32812 0.53125 0.32812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2656-0.98438c0 0.375-0.058594 0.64062-0.17188 0.79688-0.10547 0.15625-0.25 0.23438-0.4375 0.23438s-0.33594-0.070312-0.4375-0.21875c-0.09375-0.15625-0.14062-0.39062-0.14062-0.70312l0.25-0.046875c0.007813 0.19922 0.039063 0.35156 0.09375 0.45312 0.050781 0.10547 0.12891 0.15625 0.23438 0.15625 0.09375 0 0.16016-0.03125 0.20312-0.09375 0.050781-0.070312 0.082031-0.14844 0.09375-0.23438 0.007813-0.082031 0.015625-0.1875 0.015625-0.3125v-2.1094h0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.5625 0h-0.28125v-3.0625h0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219 0h-0.28125l-1.125-2.4062h-0.015625v2.4062h-0.26562v-3.0625h0.29688l1.125 2.4062v-2.4062h0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.23438-3.0625h0.75c0.125 0 0.23438 0.011719 0.32812 0.03125 0.09375 0.011719 0.17969 0.058594 0.26562 0.14062 0.09375 0.074219 0.17188 0.17188 0.23438 0.29688s0.10938 0.27344 0.14062 0.4375c0.039063 0.16797 0.0625 0.37109 0.0625 0.60938 0 0.44922-0.078125 0.82031-0.23438 1.1094-0.14844 0.29297-0.40234 0.4375-0.76562 0.4375h-0.78125zm0.29688 2.7031h0.45312c0.09375 0 0.17578-0.003906 0.25-0.015625 0.070313-0.019531 0.14453-0.066406 0.21875-0.14062 0.082031-0.082031 0.14453-0.20703 0.1875-0.375 0.050781-0.16406 0.078125-0.39062 0.078125-0.67188 0-0.14453-0.011719-0.28516-0.03125-0.42188-0.011719-0.13281-0.042969-0.25391-0.09375-0.35938-0.054688-0.11328-0.11719-0.19531-0.1875-0.25-0.0625-0.050781-0.125-0.082031-0.1875-0.09375-0.0625-0.00781-0.14844-0.015625-0.25-0.015625h-0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8438 0h-1.6094v-3.0625h1.5625v0.35938h-1.2812v0.9375h1.1875v0.35938h-1.1875v1.0469h1.3281z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1406 0h-0.35938c-0.21875-0.47656-0.35547-0.76953-0.40625-0.875-0.054688-0.11328-0.10938-0.21094-0.17188-0.29688-0.054687-0.082031-0.10547-0.13281-0.15625-0.15625-0.042969-0.019531-0.10547-0.03125-0.1875-0.03125h-0.32812v1.3594h-0.29688v-3.0625h0.95312c0.13281 0 0.24219 0.011719 0.32812 0.03125 0.09375 0.023438 0.17188 0.074219 0.23438 0.15625 0.0625 0.074219 0.10938 0.16797 0.14062 0.28125 0.039063 0.11719 0.0625 0.24219 0.0625 0.375 0 0.23047-0.054687 0.41797-0.15625 0.5625-0.10547 0.13672-0.25 0.21875-0.4375 0.25v0.015625c0.13281 0.09375 0.26953 0.28125 0.40625 0.5625zm-1.6094-1.7188h0.60938c0.11328 0 0.20703-0.015625 0.28125-0.046875 0.070313-0.03125 0.12891-0.085937 0.17188-0.17188 0.039062-0.082031 0.0625-0.17578 0.0625-0.28125 0-0.14453-0.039062-0.26562-0.10938-0.35938-0.0625-0.10156-0.17969-0.15625-0.34375-0.15625h-0.67188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 0h-0.3125l-0.25-0.9375h-0.90625l-0.23438 0.9375h-0.29688l0.82812-3.0625h0.29688zm-0.65625-1.25c-0.17969-0.66406-0.27734-1.0391-0.29688-1.125-0.023437-0.09375-0.046875-0.21875-0.078125-0.375-0.03125 0.21094-0.070312 0.40234-0.10938 0.57812l-0.25 0.92188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7656-2.7031h-0.70312v2.7031h-0.29688v-2.7031h-0.70312v-0.35938h1.7031z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9844-3.0625-0.84375 3.0625h-0.29688l-0.82812-3.0625h0.3125l0.54688 2.2188c0.039062 0.14844 0.082031 0.3125 0.125 0.5 0.03125-0.15625 0.066406-0.32031 0.10938-0.5l0.57812-2.2188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.82812-3.0625-0.60938 3.1719h-0.21875l0.625-3.1719z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5625 0h-1.3438v-3.0625h0.29688v2.7031h1.0469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.2656 0h-0.26562v-2.5625l-0.625 2.5625h-0.25l-0.625-2.6094v2.6094h-0.26562v-3.0625h0.42188l0.5 2.1719c0.0625 0.24219 0.097656 0.39062 0.10938 0.45312 0.03125-0.125 0.066406-0.28906 0.10938-0.5l0.51562-2.125h0.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6875-2.7031h-1.1562v0.95312h1v0.35938h-1v1.3906h-0.29688v-3.0625h1.4531z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219-1.2969c0 0.15625-0.00781 0.30469-0.015625 0.4375-0.011719 0.13672-0.042969 0.27734-0.09375 0.42188-0.054688 0.13672-0.14062 0.25-0.26562 0.34375-0.11719 0.09375-0.27344 0.14062-0.46875 0.14062-0.1875 0-0.33984-0.042969-0.45312-0.125-0.11719-0.082031-0.20312-0.1875-0.26562-0.3125-0.054687-0.13281-0.089844-0.27344-0.10938-0.42188-0.011719-0.14453-0.015625-0.30469-0.015625-0.48438v-1.7656h0.28125v1.7656c0 0.1875 0.007813 0.35156 0.03125 0.48438 0.019531 0.125 0.066406 0.24219 0.14062 0.34375 0.082031 0.10547 0.20703 0.15625 0.375 0.15625 0.16406 0 0.28906-0.039062 0.375-0.125 0.082031-0.082031 0.13281-0.19141 0.15625-0.32812 0.03125-0.13281 0.046875-0.3125 0.046875-0.53125v-1.7656h0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5-2.1719c-0.011719-0.1875-0.058594-0.32812-0.14062-0.42188-0.085937-0.10156-0.21094-0.15625-0.375-0.15625-0.14844 0-0.26562 0.042969-0.35938 0.125-0.09375 0.074219-0.14062 0.18359-0.14062 0.32812 0 0.13672 0.035156 0.23438 0.10938 0.29688 0.070312 0.0625 0.20703 0.125 0.40625 0.1875 0.17578 0.0625 0.32031 0.125 0.4375 0.1875 0.11328 0.054688 0.20703 0.14062 0.28125 0.26562 0.082031 0.125 0.125 0.29297 0.125 0.5 0 0.26172-0.074219 0.48047-0.21875 0.65625-0.14844 0.16797-0.33984 0.25-0.57812 0.25-0.30469 0-0.53125-0.09375-0.6875-0.28125-0.14844-0.19531-0.21875-0.44531-0.21875-0.75l0.26562-0.03125c0.007812 0.24219 0.070312 0.41797 0.1875 0.53125 0.125 0.11719 0.26953 0.17188 0.4375 0.17188 0.16406 0 0.29688-0.046875 0.39062-0.14062 0.10156-0.09375 0.15625-0.21875 0.15625-0.375 0-0.16406-0.054687-0.28516-0.15625-0.35938-0.10547-0.082031-0.27734-0.16016-0.51562-0.23438-0.24219-0.070313-0.41797-0.17578-0.53125-0.3125-0.10547-0.13281-0.15625-0.3125-0.15625-0.53125 0-0.25 0.066406-0.45312 0.20312-0.60938 0.13281-0.15625 0.31641-0.23438 0.54688-0.23438 0.23828 0 0.42969 0.078125 0.57812 0.23438 0.14453 0.15625 0.22266 0.38281 0.23438 0.67188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219 0h-0.28125v-1.4375h-1.1094v1.4375h-0.29688v-3.0625h0.29688v1.25h1.1094v-1.25h0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9844 0h-0.35938l-0.42188-0.875c-0.10547-0.20703-0.17188-0.34766-0.20312-0.42188 0 0.023437-0.21484 0.45312-0.64062 1.2969h-0.34375l0.82812-1.5938-0.73438-1.4688h0.34375l0.45312 0.90625c0.039062 0.10547 0.078125 0.1875 0.10938 0.25 0.03125-0.09375 0.22656-0.47656 0.59375-1.1562h0.3125l-0.75 1.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.5625 0h-0.28125v-3.0625h0.28125zm0.23438-3.8438-0.32812 0.57812h-0.21875l0.20312-0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-4-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 0h-0.375l-0.76562-1.5469-0.35938 0.48438v1.0625h-0.28125v-3.0625h0.28125v1.5156l1.0781-1.5156h0.375l-0.89062 1.2344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.23438-3.0625h0.75c0.125 0 0.23438 0.011719 0.32812 0.03125 0.09375 0.011719 0.17969 0.058594 0.26562 0.14062 0.09375 0.074219 0.17188 0.17188 0.23438 0.29688s0.10938 0.27344 0.14062 0.4375c0.039063 0.16797 0.0625 0.37109 0.0625 0.60938 0 0.44922-0.078125 0.82031-0.23438 1.1094-0.14844 0.29297-0.40234 0.4375-0.76562 0.4375h-0.78125zm0.29688 2.7031h0.45312c0.09375 0 0.17578-0.003906 0.25-0.015625 0.070313-0.019531 0.14453-0.066406 0.21875-0.14062 0.082031-0.082031 0.14453-0.20703 0.1875-0.375 0.050781-0.16406 0.078125-0.39062 0.078125-0.67188 0-0.14453-0.011719-0.28516-0.03125-0.42188-0.011719-0.13281-0.042969-0.25391-0.09375-0.35938-0.054688-0.11328-0.11719-0.19531-0.1875-0.25-0.0625-0.050781-0.125-0.082031-0.1875-0.09375-0.0625-0.00781-0.14844-0.015625-0.25-0.015625h-0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8438 0h-1.6094v-3.0625h1.5625v0.35938h-1.2812v0.9375h1.1875v0.35938h-1.1875v1.0469h1.3281zm-0.46875-3.8438-0.32812 0.57812h-0.21875l0.20312-0.57812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0469-0.96875c-0.0625 0.34375-0.17188 0.60156-0.32812 0.76562-0.15625 0.16797-0.34375 0.25-0.5625 0.25-0.34375 0-0.60156-0.15625-0.76562-0.46875-0.15625-0.3125-0.23438-0.6875-0.23438-1.125 0-0.48828 0.09375-0.86719 0.28125-1.1406 0.1875-0.28125 0.42969-0.42188 0.73438-0.42188 0.20703 0 0.38281 0.078125 0.53125 0.23438 0.14453 0.14844 0.25 0.36719 0.3125 0.65625l-0.28125 0.09375c-0.042969-0.21875-0.11719-0.37891-0.21875-0.48438-0.09375-0.10156-0.21484-0.15625-0.35938-0.15625-0.23047 0-0.40625 0.10938-0.53125 0.32812-0.11719 0.21875-0.17188 0.51172-0.17188 0.875 0 0.42969 0.0625 0.74609 0.1875 0.95312 0.125 0.21094 0.28906 0.3125 0.5 0.3125 0.16406 0 0.30078-0.0625 0.40625-0.1875 0.10156-0.13281 0.17578-0.33203 0.21875-0.59375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.1719-3.1094c0.30078 0 0.54688 0.14844 0.73438 0.4375 0.19531 0.28125 0.29688 0.66406 0.29688 1.1406 0 0.48047-0.10156 0.86719-0.29688 1.1562-0.1875 0.28125-0.43359 0.42188-0.73438 0.42188-0.3125 0-0.5625-0.14453-0.75-0.4375-0.1875-0.30078-0.28125-0.67188-0.28125-1.1094 0-0.5 0.09375-0.89062 0.28125-1.1719 0.19531-0.28906 0.44531-0.4375 0.75-0.4375zm0 2.8125c0.21875 0 0.39453-0.10938 0.53125-0.32812 0.13281-0.21875 0.20312-0.51953 0.20312-0.90625 0-0.39453-0.074219-0.69531-0.21875-0.90625-0.13672-0.21875-0.30859-0.32812-0.51562-0.32812-0.21875 0-0.39844 0.10547-0.53125 0.3125-0.13672 0.21094-0.20312 0.53125-0.20312 0.96875 0 0.35547 0.066406 0.64062 0.20312 0.85938 0.13281 0.21875 0.3125 0.32812 0.53125 0.32812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1406 0h-0.35938c-0.21875-0.47656-0.35547-0.76953-0.40625-0.875-0.054688-0.11328-0.10938-0.21094-0.17188-0.29688-0.054687-0.082031-0.10547-0.13281-0.15625-0.15625-0.042969-0.019531-0.10547-0.03125-0.1875-0.03125h-0.32812v1.3594h-0.29688v-3.0625h0.95312c0.13281 0 0.24219 0.011719 0.32812 0.03125 0.09375 0.023438 0.17188 0.074219 0.23438 0.15625 0.0625 0.074219 0.10938 0.16797 0.14062 0.28125 0.039063 0.11719 0.0625 0.24219 0.0625 0.375 0 0.23047-0.054687 0.41797-0.15625 0.5625-0.10547 0.13672-0.25 0.21875-0.4375 0.25v0.015625c0.13281 0.09375 0.26953 0.28125 0.40625 0.5625zm-1.6094-1.7188h0.60938c0.11328 0 0.20703-0.015625 0.28125-0.046875 0.070313-0.03125 0.12891-0.085937 0.17188-0.17188 0.039062-0.082031 0.0625-0.17578 0.0625-0.28125 0-0.14453-0.039062-0.26562-0.10938-0.35938-0.0625-0.10156-0.17969-0.15625-0.34375-0.15625h-0.67188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 0h-0.3125l-0.25-0.9375h-0.90625l-0.23438 0.9375h-0.29688l0.82812-3.0625h0.29688zm-0.65625-1.25c-0.17969-0.66406-0.27734-1.0391-0.29688-1.125-0.023437-0.09375-0.046875-0.21875-0.078125-0.375-0.03125 0.21094-0.070312 0.40234-0.10938 0.57812l-0.25 0.92188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7656-2.7031h-0.70312v2.7031h-0.29688v-2.7031h-0.70312v-0.35938h1.7031z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.5625 0h-0.28125v-3.0625h0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219 0h-0.28125l-1.125-2.4062h-0.015625v2.4062h-0.26562v-3.0625h0.29688l1.125 2.4062v-2.4062h0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.82812-3.0625-0.60938 3.1719h-0.21875l0.625-3.1719z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5-2.1719c-0.011719-0.1875-0.058594-0.32812-0.14062-0.42188-0.085937-0.10156-0.21094-0.15625-0.375-0.15625-0.14844 0-0.26562 0.042969-0.35938 0.125-0.09375 0.074219-0.14062 0.18359-0.14062 0.32812 0 0.13672 0.035156 0.23438 0.10938 0.29688 0.070312 0.0625 0.20703 0.125 0.40625 0.1875 0.17578 0.0625 0.32031 0.125 0.4375 0.1875 0.11328 0.054688 0.20703 0.14062 0.28125 0.26562 0.082031 0.125 0.125 0.29297 0.125 0.5 0 0.26172-0.074219 0.48047-0.21875 0.65625-0.14844 0.16797-0.33984 0.25-0.57812 0.25-0.30469 0-0.53125-0.09375-0.6875-0.28125-0.14844-0.19531-0.21875-0.44531-0.21875-0.75l0.26562-0.03125c0.007812 0.24219 0.070312 0.41797 0.1875 0.53125 0.125 0.11719 0.26953 0.17188 0.4375 0.17188 0.16406 0 0.29688-0.046875 0.39062-0.14062 0.10156-0.09375 0.15625-0.21875 0.15625-0.375 0-0.16406-0.054687-0.28516-0.15625-0.35938-0.10547-0.082031-0.27734-0.16016-0.51562-0.23438-0.24219-0.070313-0.41797-0.17578-0.53125-0.3125-0.10547-0.13281-0.15625-0.3125-0.15625-0.53125 0-0.25 0.066406-0.45312 0.20312-0.60938 0.13281-0.15625 0.31641-0.23438 0.54688-0.23438 0.23828 0 0.42969 0.078125 0.57812 0.23438 0.14453 0.15625 0.22266 0.38281 0.23438 0.67188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8438 0h-1.6094v-3.0625h1.5625v0.35938h-1.2812v0.9375h1.1875v0.35938h-1.1875v1.0469h1.3281z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 0h-0.375l-0.76562-1.5469-0.35938 0.48438v1.0625h-0.28125v-3.0625h0.28125v1.5156l1.0781-1.5156h0.375l-0.89062 1.2344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219-1.2969c0 0.15625-0.00781 0.30469-0.015625 0.4375-0.011719 0.13672-0.042969 0.27734-0.09375 0.42188-0.054688 0.13672-0.14062 0.25-0.26562 0.34375-0.11719 0.09375-0.27344 0.14062-0.46875 0.14062-0.1875 0-0.33984-0.042969-0.45312-0.125-0.11719-0.082031-0.20312-0.1875-0.26562-0.3125-0.054687-0.13281-0.089844-0.27344-0.10938-0.42188-0.011719-0.14453-0.015625-0.30469-0.015625-0.48438v-1.7656h0.28125v1.7656c0 0.1875 0.007813 0.35156 0.03125 0.48438 0.019531 0.125 0.066406 0.24219 0.14062 0.34375 0.082031 0.10547 0.20703 0.15625 0.375 0.15625 0.16406 0 0.28906-0.039062 0.375-0.125 0.082031-0.082031 0.13281-0.19141 0.15625-0.32812 0.03125-0.13281 0.046875-0.3125 0.046875-0.53125v-1.7656h0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9844-3.0625-0.84375 3.0625h-0.29688l-0.82812-3.0625h0.3125l0.54688 2.2188c0.039062 0.14844 0.082031 0.3125 0.125 0.5 0.03125-0.15625 0.066406-0.32031 0.10938-0.5l0.57812-2.2188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.75 0h-1.7031v-0.375l1.1094-1.9688s0.023438-0.039062 0.078125-0.125c0.050781-0.09375 0.097656-0.17188 0.14062-0.23438h-1.2031v-0.35938h1.5469v0.35938l-1.2031 2.125-0.14062 0.21875h1.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0312 0h-2.0156l0.82812-3.0625h0.3125zm-0.42188-0.35938-0.46875-1.7812c-0.074219-0.25-0.12109-0.44531-0.14062-0.59375-0.042969 0.19922-0.085938 0.40234-0.125 0.60938l-0.46875 1.7656z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.5625 0h-0.28125v-3.0625h0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 0h-0.3125l-0.25-0.9375h-0.90625l-0.23438 0.9375h-0.29688l0.82812-3.0625h0.29688zm-0.65625-1.25c-0.17969-0.66406-0.27734-1.0391-0.29688-1.125-0.023437-0.09375-0.046875-0.21875-0.078125-0.375-0.03125 0.21094-0.070312 0.40234-0.10938 0.57812l-0.25 0.92188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 0h-0.375l-0.76562-1.5469-0.35938 0.48438v1.0625h-0.28125v-3.0625h0.28125v1.5156l1.0781-1.5156h0.375l-0.89062 1.2344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.1719-3.1094c0.30078 0 0.54688 0.14844 0.73438 0.4375 0.19531 0.28125 0.29688 0.66406 0.29688 1.1406 0 0.48047-0.10156 0.86719-0.29688 1.1562-0.1875 0.28125-0.43359 0.42188-0.73438 0.42188-0.3125 0-0.5625-0.14453-0.75-0.4375-0.1875-0.30078-0.28125-0.67188-0.28125-1.1094 0-0.5 0.09375-0.89062 0.28125-1.1719 0.19531-0.28906 0.44531-0.4375 0.75-0.4375zm0 2.8125c0.21875 0 0.39453-0.10938 0.53125-0.32812 0.13281-0.21875 0.20312-0.51953 0.20312-0.90625 0-0.39453-0.074219-0.69531-0.21875-0.90625-0.13672-0.21875-0.30859-0.32812-0.51562-0.32812-0.21875 0-0.39844 0.10547-0.53125 0.3125-0.13672 0.21094-0.20312 0.53125-0.20312 0.96875 0 0.35547 0.066406 0.64062 0.20312 0.85938 0.13281 0.21875 0.3125 0.32812 0.53125 0.32812z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6562 0h-1.5156v-0.42188l0.70312-1.1719-0.70312-1.0625v-0.40625h1.4688v0.35938h-1.1562l0.73438 1.1094-0.73438 1.2344h1.2031z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.2656 0h-0.26562v-2.5625l-0.625 2.5625h-0.25l-0.625-2.6094v2.6094h-0.26562v-3.0625h0.42188l0.5 2.1719c0.0625 0.24219 0.097656 0.39062 0.10938 0.45312 0.03125-0.125 0.066406-0.28906 0.10938-0.5l0.51562-2.125h0.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9219 0h-0.28125v-1.4375h-1.1094v1.4375h-0.29688v-3.0625h0.29688v1.25h1.1094v-1.25h0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7656-2.7031h-0.70312v2.7031h-0.29688v-2.7031h-0.70312v-0.35938h1.7031z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.75-2.7031h-1.5469v-0.35938h1.5469zm-0.14062 1.3438h-1.2812v-0.35938h1.2812zm0.1875 1.3594h-1.6406v-0.35938h1.6406z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9844 0h-0.3125l-0.5625-2.2188c-0.054687-0.19531-0.089844-0.36719-0.10938-0.51562-0.03125 0.16797-0.070312 0.33984-0.10938 0.51562l-0.59375 2.2188h-0.28125l0.84375-3.0625h0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.23438-3.0625h0.8125c0.125 0 0.23438 0.011719 0.32812 0.03125 0.09375 0.011719 0.17578 0.058594 0.25 0.14062 0.082031 0.074219 0.14453 0.17969 0.1875 0.3125 0.039062 0.125 0.0625 0.26172 0.0625 0.40625 0 0.28125-0.070312 0.51172-0.20312 0.6875-0.125 0.16797-0.32812 0.25-0.60938 0.25h-0.54688v1.2344h-0.28125zm0.28125 1.4531h0.54688c0.34375 0 0.51562-0.1875 0.51562-0.5625 0-0.11328-0.027344-0.21875-0.078125-0.3125-0.042969-0.09375-0.09375-0.14844-0.15625-0.17188-0.0625-0.03125-0.15625-0.046875-0.28125-0.046875h-0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.23438-3.0625h0.8125c0.125 0 0.23438 0.011719 0.32812 0.03125 0.09375 0.011719 0.17578 0.058594 0.25 0.14062 0.082031 0.074219 0.14453 0.17969 0.1875 0.3125 0.039062 0.125 0.0625 0.26172 0.0625 0.40625 0 0.28125-0.070312 0.51172-0.20312 0.6875-0.125 0.16797-0.32812 0.25-0.60938 0.25h-0.54688v1.2344h-0.28125zm0.28125 1.4531h0.54688c0.34375 0 0.51562-0.1875 0.51562-0.5625 0-0.11328-0.027344-0.21875-0.078125-0.3125-0.042969-0.09375-0.09375-0.14844-0.15625-0.17188-0.0625-0.03125-0.15625-0.046875-0.28125-0.046875h-0.54688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.8438-2.6562-0.20312 0.125c-0.042969-0.23828-0.089844-0.42969-0.14062-0.57812l0.21875-0.125c0.050781 0.15625 0.09375 0.35156 0.125 0.57812zm-0.82812-0.125h-1.5v-0.39062h1.5zm0.5 0.29688-0.21875 0.10938c-0.03125-0.22656-0.078125-0.41406-0.14062-0.5625l0.21875-0.125c0.0625 0.15625 0.10938 0.35156 0.14062 0.57812zm0.20312 0.75h-1.0625v0.17188c0 0.85547-0.26172 1.4648-0.78125 1.8281l-0.21875-0.34375c0.23828-0.125 0.42188-0.30469 0.54688-0.54688 0.125-0.25 0.1875-0.53906 0.1875-0.875v-0.23438h-1.1719v-0.375h2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5781 0.09375h-0.26562v-0.17188h-2.0156v-0.375h2.0156v-2.2969h-1.9844v-0.39062h2.25z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.6719-1.2656c-0.25 0.42969-0.57031 0.76562-0.95312 1.0156-0.38672 0.25-0.75781 0.375-1.1094 0.375v-3.5h0.26562v3.0938c0.28125-0.039062 0.5625-0.17188 0.84375-0.39062 0.28125-0.22656 0.53516-0.52344 0.76562-0.89062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.75-1.4531h-2.5v-0.39062h2.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5469-2.9688-0.10938 0.39062c-0.26172-0.21875-0.5625-0.35156-0.90625-0.40625l0.09375-0.39062c0.38281 0.11719 0.69141 0.25 0.92188 0.40625zm1.1719 0.82812c-0.28125 0.625-0.59375 1.1211-0.9375 1.4844-0.34375 0.36719-0.76172 0.64062-1.25 0.82812l-0.14062-0.40625c0.50781-0.16406 0.92969-0.42578 1.2656-0.78125 0.34375-0.35156 0.61719-0.81641 0.82812-1.3906zm-1.4688 0.25-0.09375 0.40625c-0.24219-0.22656-0.54297-0.375-0.90625-0.4375l0.09375-0.39062c0.375 0.10547 0.67578 0.24609 0.90625 0.42188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.2969-0.34375h-0.25v-0.14062h-1.4375v-0.34375h1.4375v-0.64062h-1.3438v-0.35938h1.3438v-0.5625h-1.375v-0.34375h1.625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.3438-2.6094-0.17188 0.34375c-0.24219-0.28906-0.52344-0.49219-0.84375-0.60938l0.15625-0.35938c0.34375 0.1875 0.62891 0.39844 0.85938 0.625zm1.3438 0.4375c-0.34375 0.73047-0.6875 1.2578-1.0312 1.5781-0.33594 0.32422-0.71484 0.57031-1.1406 0.73438l-0.17188-0.39062c0.53125-0.15625 0.95703-0.41406 1.2812-0.78125 0.32031-0.36328 0.60156-0.83203 0.84375-1.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5781-2.6875c-0.1875 1.4297-0.75 2.3906-1.6875 2.8906l-0.1875-0.34375c0.45703-0.22656 0.80469-0.53125 1.0469-0.90625 0.25-0.38281 0.42188-0.875 0.51562-1.4688h-1.0938c-0.1875 0.39844-0.39062 0.71875-0.60938 0.96875l-0.20312-0.3125c0.1875-0.17578 0.35938-0.41406 0.51562-0.71875 0.16406-0.3125 0.28125-0.61328 0.34375-0.90625l0.28125 0.14062c-0.054688 0.14844-0.10547 0.29688-0.15625 0.45312h1.0781z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.625-1.9531-0.25 0.14062c-0.054688-0.36328-0.13672-0.66406-0.25-0.90625l0.25-0.125c0.11328 0.32422 0.19531 0.62109 0.25 0.89062zm0.625-0.79688c-0.03125 1.1875-0.43359 2.0156-1.2031 2.4844l-0.1875-0.3125c0.375-0.19531 0.65625-0.47266 0.84375-0.82812 0.19531-0.36328 0.29688-0.78125 0.29688-1.25 0-0.070312-0.007812-0.125-0.015625-0.15625zm-1.1562 1-0.23438 0.14062c-0.085937-0.38281-0.18359-0.6875-0.29688-0.90625l0.25-0.14062c0.14453 0.34375 0.23828 0.64844 0.28125 0.90625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.8125-2.2969h-0.48438v0.96875h-0.21875v-2.2812h0.21875v0.98438h0.48438zm-1.0469 0.64062c-0.10547 0.09375-0.17969 0.18359-0.21875 0.26562-0.28125-0.32031-0.46875-0.61328-0.5625-0.875-0.125 0.3125-0.30469 0.62109-0.53125 0.92188-0.085937-0.125-0.15234-0.21094-0.20312-0.26562 0.375-0.40625 0.58203-0.85938 0.625-1.3594h-0.54688v-0.34375h1.3906v0.34375h-0.59375l-0.015625 0.25c0 0.074219 0.054687 0.22656 0.17188 0.45312 0.125 0.23047 0.28516 0.43359 0.48438 0.60938zm0.625 1.1719c0 0.23047-0.085937 0.41406-0.25 0.54688-0.16797 0.14453-0.38281 0.21875-0.64062 0.21875-0.27344 0-0.49219-0.070312-0.65625-0.20312-0.16797-0.125-0.25-0.3125-0.25-0.5625 0-0.21875 0.082031-0.39844 0.25-0.54688 0.16406-0.15625 0.38281-0.23438 0.65625-0.23438 0.25781 0 0.47266 0.074219 0.64062 0.21875 0.16406 0.14844 0.25 0.33594 0.25 0.5625zm-0.26562 0.015625c0-0.13281-0.058594-0.24219-0.17188-0.32812-0.11719-0.082031-0.26562-0.125-0.45312-0.125-0.19922 0-0.35547 0.042969-0.46875 0.125-0.11719 0.085937-0.17188 0.19531-0.17188 0.32812 0 0.125 0.054687 0.23047 0.17188 0.3125 0.125 0.085938 0.28125 0.125 0.46875 0.125s0.33594-0.039062 0.45312-0.125c0.11328-0.082031 0.17188-0.1875 0.17188-0.3125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5-1.3281v-2.2812h0.21875v2.2812zm-1.1406-2.0781c-0.03125 0.0625-0.046875 0.17188-0.046875 0.32812l-0.015625 0.20312c0 0.09375 0.066406 0.26562 0.20312 0.51562 0.13281 0.24219 0.31641 0.45312 0.54688 0.64062-0.0625 0.0625-0.12109 0.15625-0.17188 0.28125-0.29297-0.26953-0.52734-0.59375-0.70312-0.96875-0.17969 0.41797-0.40234 0.76172-0.67188 1.0312-0.042969-0.10156-0.10547-0.19141-0.1875-0.26562 0.21875-0.16406 0.39844-0.39062 0.54688-0.67188 0.14453-0.28906 0.21875-0.67188 0.21875-1.1406zm1.1406 3.6719v-1.0625h-1.7344v-0.32812h1.9531v1.3906z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7656-1.7969v0.32812h-2.5312v-0.32812h0.75v-0.35938c-0.3125-0.125-0.46875-0.32812-0.46875-0.60938 0-0.1875 0.09375-0.34766 0.28125-0.48438 0.19531-0.13281 0.42969-0.20312 0.70312-0.20312 0.26953 0 0.5 0.070313 0.6875 0.20312 0.19531 0.13672 0.29688 0.29688 0.29688 0.48438 0 0.26172-0.15625 0.46484-0.46875 0.60938v0.35938zm-1.2656-0.59375c0.20703 0 0.375-0.035156 0.5-0.10938 0.13281-0.070312 0.20312-0.16016 0.20312-0.26562 0-0.10156-0.070313-0.19141-0.20312-0.26562-0.125-0.070312-0.29297-0.10938-0.5-0.10938-0.19922 0-0.36719 0.039063-0.5 0.10938-0.13672 0.074219-0.20312 0.16406-0.20312 0.26562 0 0.10547 0.066406 0.19531 0.20312 0.26562 0.13281 0.074219 0.30078 0.10938 0.5 0.10938zm0.29688 0.59375v-0.29688c-0.09375 0.023438-0.19531 0.03125-0.29688 0.03125-0.10547 0-0.19922-0.00391-0.28125-0.015625v0.28125zm0.71875 1.3281c0 0.24219-0.09375 0.42969-0.28125 0.5625-0.1875 0.13281-0.43359 0.20312-0.73438 0.20312-0.30469 0-0.54688-0.070313-0.73438-0.20312-0.1875-0.13281-0.28125-0.32031-0.28125-0.5625 0-0.23828 0.097656-0.42578 0.29688-0.5625 0.19531-0.14453 0.4375-0.21875 0.71875-0.21875 0.30078 0 0.54688 0.070312 0.73438 0.20312 0.1875 0.13672 0.28125 0.32812 0.28125 0.57812zm-0.98438-0.4375c-0.23047 0-0.42188 0.042969-0.57812 0.125-0.14844 0.074219-0.21875 0.17969-0.21875 0.3125 0 0.11719 0.078125 0.21875 0.23438 0.3125 0.16406 0.085938 0.34375 0.125 0.53125 0.125 0.20703 0 0.38281-0.039062 0.53125-0.125 0.15625-0.09375 0.23438-0.19531 0.23438-0.3125 0-0.125-0.074219-0.22656-0.21875-0.3125-0.13672-0.082031-0.30859-0.125-0.51562-0.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7812-1.3594h-1.1562v1.6406h-0.23438v-1.6406h-1.125v-0.32812h1.7969c0.019531-0.16406 0.039062-0.36328 0.0625-0.59375-0.57422 0.074219-1.0938 0.125-1.5625 0.15625l-0.046875-0.40625c0.57031 0.011719 1.1133-0.00781 1.625-0.0625 0.019531-0.15625 0.035156-0.3125 0.046875-0.46875h-1.625v-0.34375h1.9062c-0.023438 0.44922-0.070312 1.0234-0.14062 1.7188h0.45312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7188-0.70312h-0.21875v-1.0469h-0.6875v-0.32812h0.6875v-0.39062h-0.6875v-0.32812h0.6875v-0.79688h0.21875zm-1.4688-2.5781c-0.023438 0.0625-0.042969 0.19531-0.0625 0.39062l-0.03125 0.28125c0 0.09375 0.066406 0.28906 0.20312 0.57812 0.13281 0.28125 0.32031 0.53125 0.5625 0.75-0.085937 0.042969-0.15625 0.14062-0.21875 0.29688-0.28125-0.32031-0.50781-0.70312-0.67188-1.1406-0.14844 0.46094-0.37109 0.85938-0.67188 1.2031-0.03125-0.10156-0.09375-0.20703-0.1875-0.3125 0.16406-0.16406 0.30469-0.35938 0.42188-0.57812 0.125-0.21875 0.21094-0.42969 0.26562-0.64062 0.050781-0.21875 0.078125-0.36719 0.078125-0.45312v-0.4375zm1.4688 3.4844h-1.9844v-1.3125h0.23438v0.96875h1.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9844-3.0625-0.85938 1.7656v1.2969h-0.28125v-1.2969l-0.82812-1.7656h0.34375l0.46875 1.0312c0.050781 0.10547 0.10938 0.24219 0.17188 0.40625 0.039062-0.11328 0.25781-0.59375 0.65625-1.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4375 0h-0.015625c-0.13672 0-0.24609-0.039062-0.32812-0.125-0.074219-0.09375-0.12109-0.22656-0.14062-0.40625-0.03125 0.074219-0.085937 0.13672-0.15625 0.1875-0.0625 0.054688-0.13672 0.078125-0.21875 0.078125-0.11719 0-0.21094-0.050781-0.28125-0.15625-0.074219-0.10156-0.10938-0.24219-0.10938-0.42188 0-0.1875 0.050781-0.35938 0.15625-0.51562 0.11328-0.16406 0.27344-0.28906 0.48438-0.375l-0.015625-0.17188h0.26562l0.0625 0.75c0.019531 0.26172 0.035156 0.41797 0.046875 0.46875 0.00781 0.054688 0.023438 0.10547 0.046875 0.15625 0.019531 0.042969 0.046875 0.074219 0.078125 0.09375 0.03125 0.023438 0.066406 0.03125 0.10938 0.03125h0.015625zm-0.57812-1.4375c-0.26172 0.10547-0.39062 0.30469-0.39062 0.59375 0 0.054688 0.015625 0.10156 0.046875 0.14062 0.03125 0.03125 0.066406 0.046875 0.10938 0.046875 0.050781 0 0.10938-0.035156 0.17188-0.10938 0.0625-0.070313 0.09375-0.14844 0.09375-0.23438 0-0.019531-0.011719-0.16406-0.03125-0.4375zm0.15625-0.95312h-0.21875v-0.29688h0.21875zm-0.39062 0h-0.21875v-0.29688h0.21875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.73438 0c-0.16797 0-0.29297-0.054688-0.375-0.17188-0.074219 0.11719-0.19531 0.17188-0.35938 0.17188v-0.40625h0.015625c0.14453 0 0.21875-0.14062 0.21875-0.42188v-0.39062h0.26562v0.39062c0 0.28125 0.070312 0.42188 0.21875 0.42188h0.015625zm-0.0625 0.59375h-0.21875v-0.29688h0.21875zm-0.39062 0h-0.21875v-0.29688h0.21875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.73438 0c-0.16797 0-0.29297-0.054688-0.375-0.17188-0.074219 0.11719-0.19531 0.17188-0.35938 0.17188v-0.40625h0.015625c0.14453 0 0.21875-0.14062 0.21875-0.42188v-0.39062h0.26562v0.39062c0 0.28125 0.070312 0.42188 0.21875 0.42188h0.015625zm-0.23438-1.7812h-0.26562v-0.375h0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.57812-0.82812c0 0.30469-0.042969 0.51562-0.125 0.64062-0.074219 0.125-0.19531 0.1875-0.35938 0.1875h-0.09375v-0.40625h0.10938c0.14453 0 0.21875-0.14062 0.21875-0.42188v-0.39062h0.25zm0.078125 1.4219h-0.21875v-0.29688h0.21875zm-0.39062 0h-0.21875v-0.29688h0.21875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.3125 0c-0.125 0-0.21484-0.035156-0.26562-0.10938-0.042969 0.32031-0.15234 0.57031-0.32812 0.75-0.17969 0.17578-0.39844 0.26562-0.65625 0.26562-0.0625 0-0.15625-0.011719-0.28125-0.03125l0.046875-0.375c0.09375 0.019531 0.17188 0.03125 0.23438 0.03125 0.5 0 0.75-0.32812 0.75-0.98438 0-0.16406-0.027344-0.35156-0.078125-0.5625h0.28125c0.019531 0.125 0.035156 0.24609 0.046875 0.35938 0.00781 0.16797 0.085938 0.25 0.23438 0.25h0.015625zm-0.34375-1.5938h-0.26562v-0.375h0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.57812-0.82812c0 0.30469-0.042969 0.51562-0.125 0.64062-0.074219 0.125-0.19531 0.1875-0.35938 0.1875h-0.09375v-0.40625h0.10938c0.14453 0 0.21875-0.14062 0.21875-0.42188v-0.39062h0.25zm0.078125-0.95312h-0.21875v-0.29688h0.21875zm-0.39062 0h-0.21875v-0.29688h0.21875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.76562-1.8438c0.39453 0.28125 0.59375 0.63281 0.59375 1.0469 0 0.27344-0.054687 0.48047-0.15625 0.625-0.10547 0.13672-0.25 0.20312-0.4375 0.20312-0.17969 0-0.32031-0.070312-0.42188-0.21875-0.10547-0.14453-0.15625-0.34766-0.15625-0.60938 0-0.20703 0.046875-0.39844 0.14062-0.57812 0.10156-0.1875 0.25-0.34375 0.4375-0.46875zm0.34375 1.0469c0-0.13281-0.039063-0.26562-0.10938-0.39062-0.0625-0.125-0.14062-0.22266-0.23438-0.29688-0.09375 0.085937-0.17188 0.1875-0.23438 0.3125s-0.09375 0.25-0.09375 0.375c0 0.28125 0.10938 0.42188 0.32812 0.42188 0.10156 0 0.1875-0.035156 0.25-0.10938 0.0625-0.070313 0.09375-0.17578 0.09375-0.3125zm-0.015625-1.6094h-0.21875v-0.29688h0.21875zm-0.39062 0h-0.21875v-0.29688h0.21875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.67188-1.875c0.28906 0.51172 0.4375 0.85938 0.4375 1.0469 0 0.26172-0.078125 0.46484-0.23438 0.60938-0.15625 0.14844-0.38281 0.21875-0.67188 0.21875h-0.09375v-0.40625h0.09375c0.42578 0 0.64062-0.14062 0.64062-0.42188 0-0.17578-0.16406-0.52344-0.48438-1.0469z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.82812 0h-0.09375c-0.17969 0-0.30859-0.0625-0.39062-0.1875-0.074219-0.13281-0.10938-0.34766-0.10938-0.64062v-2.2344h0.26562v2.2344c0 0.28125 0.070312 0.42188 0.21875 0.42188h0.10938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.0781-0.875c0 0.28125-0.042969 0.5-0.125 0.65625-0.085937 0.14844-0.20312 0.21875-0.35938 0.21875h-0.03125c-0.16797 0-0.29297-0.0625-0.375-0.1875-0.03125 0.054688-0.085938 0.10156-0.15625 0.14062-0.0625 0.03125-0.11719 0.046875-0.15625 0.046875-0.14844 0-0.25-0.0625-0.3125-0.1875-0.085938 0.125-0.20312 0.1875-0.35938 0.1875h-0.20312v-0.40625h0.1875c0.15625 0 0.23438-0.14062 0.23438-0.42188v-0.39062h0.25v0.34375c0 0.16797 0.015625 0.28906 0.046875 0.35938 0.03125 0.074219 0.082031 0.10938 0.15625 0.10938 0.0625 0 0.10938-0.035156 0.14062-0.10938 0.03125-0.070313 0.046875-0.19141 0.046875-0.35938v-0.34375h0.25v0.32812c0 0.32422 0.082031 0.48438 0.25 0.48438h0.03125c0.14453 0 0.21875-0.16016 0.21875-0.48438v-0.59375h0.26562z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.9375-0.4375c-0.054688 0.011719-0.10547 0.015625-0.15625 0.015625-0.14844 0-0.28125-0.066406-0.40625-0.20312-0.125-0.14453-0.1875-0.34375-0.1875-0.59375 0-0.22656 0.046875-0.42188 0.14062-0.57812 0.10156-0.15625 0.22266-0.23438 0.35938-0.23438 0.13281 0 0.25391 0.12109 0.35938 0.35938 0.11328 0.23047 0.17188 0.52734 0.17188 0.89062 0 0.28125-0.058594 0.55469-0.17188 0.8125-0.11719 0.26953-0.27344 0.48438-0.46875 0.64062-0.1875 0.15625-0.39062 0.23438-0.60938 0.23438-0.070312 0-0.17188-0.011719-0.29688-0.03125l0.0625-0.42188c0.085937 0.03125 0.16406 0.046875 0.23438 0.046875 0.23828 0 0.44531-0.09375 0.625-0.28125 0.17578-0.17969 0.28906-0.39453 0.34375-0.65625zm0.03125-0.42188c-0.011719-0.19531-0.046875-0.375-0.10938-0.53125-0.054687-0.15625-0.10938-0.23438-0.17188-0.23438s-0.12109 0.042969-0.17188 0.125c-0.042969 0.074219-0.0625 0.16797-0.0625 0.28125 0 0.10547 0.03125 0.19922 0.09375 0.28125 0.0625 0.074219 0.13281 0.10938 0.21875 0.10938 0.082031 0 0.14844-0.007813 0.20312-0.03125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.1406-0.42188c-0.27344 0.3125-0.57031 0.46875-0.89062 0.46875-0.32422 0-0.58984-0.14062-0.79688-0.42188-0.19922-0.28906-0.29688-0.67188-0.29688-1.1406 0-0.28906 0.039062-0.5625 0.125-0.8125 0.082031-0.25 0.20312-0.44141 0.35938-0.57812 0.16406-0.13281 0.36328-0.20312 0.59375-0.20312 0.23828 0 0.42969 0.078125 0.57812 0.23438 0.14453 0.14844 0.24219 0.37109 0.29688 0.67188l-0.25 0.09375c-0.042969-0.21875-0.11719-0.37891-0.21875-0.48438-0.10547-0.11328-0.24219-0.17188-0.40625-0.17188-0.26172 0-0.46094 0.11719-0.59375 0.34375-0.125 0.21875-0.1875 0.51172-0.1875 0.875 0 0.27344 0.03125 0.5 0.09375 0.6875 0.0625 0.17969 0.15625 0.3125 0.28125 0.40625s0.25781 0.14062 0.40625 0.14062c0.22656 0 0.4375-0.10156 0.625-0.3125v-0.57812h-0.625v-0.35938h0.90625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-5-99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.84375 0h-0.84375v-0.40625h0.84375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5156 0v-0.375h-1.6406l1.6094-2.4688v-0.03125h-2.1719v0.375h1.4844l-1.6094 2.4688v0.03125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.3594-2.9062c-0.375 0-0.70312 0.09375-0.875 0.17188v0.40625c0.15625-0.078125 0.45312-0.20312 0.79688-0.20312 0.60938 0 0.79688 0.29688 0.79688 0.79688v0.26562c-0.17188-0.078125-0.48438-0.17188-0.8125-0.17188-0.67188 0-1 0.35938-1 0.85938s0.35938 0.8125 0.875 0.8125c0.48438 0 0.79688-0.23438 0.9375-0.39062v0.35938h0.45312v-1.7812c0-0.70312-0.34375-1.125-1.1719-1.125zm0.71875 2.2344c-0.125 0.17188-0.375 0.39062-0.76562 0.39062-0.42188 0-0.59375-0.23438-0.59375-0.51562 0-0.32812 0.20312-0.5625 0.65625-0.5625 0.26562 0 0.53125 0.09375 0.70312 0.15625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9375-2.875c-0.48438 0-0.79688 0.28125-0.9375 0.48438v-0.48438h-0.45312v2.875h0.45312v-2.0156c0.14062-0.1875 0.4375-0.42188 0.8125-0.42188 0.0625 0 0.125 0 0.15625 0.015625h0.015625v-0.45312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9688-2.9062c-0.46875 0-0.8125 0.25-0.96875 0.46875v-1.7656h-0.45312v4.2031h0.45312v-2.0781c0.14062-0.20312 0.4375-0.45312 0.8125-0.45312 0.39062 0 0.65625 0.20312 0.65625 0.70312v1.8281h0.45312v-1.9375c0-0.64062-0.42188-0.96875-0.95312-0.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6562-2.9531c-0.78125 0-1.3594 0.59375-1.3594 1.5156s0.57812 1.5156 1.3594 1.5156 1.375-0.59375 1.375-1.5156-0.59375-1.5156-1.375-1.5156zm0 2.6406c-0.51562 0-0.89062-0.4375-0.89062-1.125s0.375-1.1094 0.89062-1.1094c0.53125 0 0.90625 0.42188 0.90625 1.1094s-0.375 1.125-0.90625 1.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.7969-2.9062c-0.51562 0-0.85938 0.26562-1.0156 0.5-0.14062-0.32812-0.46875-0.5-0.82812-0.5-0.48438 0-0.8125 0.26562-0.95312 0.46875v-0.4375h-0.45312v2.875h0.45312v-2.0625c0.10938-0.20312 0.39062-0.46875 0.75-0.46875 0.375 0 0.65625 0.1875 0.65625 0.6875v1.8438h0.46875v-1.9688c0-0.046875 0-0.078125-0.015625-0.10938 0.14062-0.21875 0.40625-0.45312 0.75-0.45312 0.39062 0 0.67188 0.20312 0.67188 0.6875v1.8438h0.45312v-1.9844c0-0.65625-0.46875-0.92188-0.9375-0.92188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.7812-1.6094c0-0.9375-0.57812-1.3438-1.1875-1.3438-0.70312 0-1.2969 0.51562-1.2969 1.5156 0 0.95312 0.5625 1.4688 1.4062 1.4688 0.4375 0 0.78125-0.14062 0.95312-0.25v-0.40625h-0.015625c-0.15625 0.125-0.46875 0.28125-0.90625 0.28125-0.65625 0-0.96875-0.40625-0.98438-1h2.0156s0.015625-0.125 0.015625-0.26562zm-2.0312-0.046875c0.03125-0.625 0.375-0.9375 0.84375-0.9375 0.42188 0 0.73438 0.32812 0.73438 0.85938v0.078125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.65625 0.03125c0.17188 0 0.29688-0.125 0.29688-0.29688s-0.125-0.29688-0.29688-0.29688-0.29688 0.125-0.29688 0.29688 0.125 0.29688 0.29688 0.29688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-13-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.29688-1.4375c0 0.85938 0.54688 1.4688 1.4062 1.4688 0.35938 0 0.625-0.10938 0.75-0.1875v-0.4375h-0.015625c-0.14062 0.10938-0.39062 0.23438-0.71875 0.23438-0.51562 0-0.95312-0.34375-0.95312-1.0781s0.4375-1.0781 0.95312-1.0781c0.32812 0 0.57812 0.14062 0.71875 0.23438h0.015625v-0.4375c-0.125-0.078125-0.39062-0.1875-0.75-0.1875-0.85938 0-1.4062 0.60938-1.4062 1.4688z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.4375-1.8438 1.375-0.14062c0.039062 0.3125 0.15625 0.55859 0.34375 0.73438 0.19531 0.17969 0.42188 0.26562 0.67188 0.26562 0.28125 0 0.51953-0.11328 0.71875-0.34375 0.19531-0.22656 0.29688-0.57812 0.29688-1.0469 0-0.4375-0.10156-0.76562-0.29688-0.98438-0.19922-0.22656-0.45312-0.34375-0.76562-0.34375-0.39844 0-0.75 0.17969-1.0625 0.53125l-1.1094-0.15625 0.70312-3.7344h3.625v1.2812h-2.5781l-0.21875 1.2188c0.30078-0.15625 0.61328-0.23438 0.9375-0.23438 0.60156 0 1.1172 0.22656 1.5469 0.67188 0.42578 0.4375 0.64062 1.0117 0.64062 1.7188 0 0.59375-0.17188 1.1211-0.51562 1.5781-0.46875 0.63672-1.1172 0.95312-1.9375 0.95312-0.66797 0-1.2109-0.17578-1.625-0.53125-0.41797-0.35156-0.66797-0.83203-0.75-1.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.75-7.1875c0.6875 0 1.2266 0.24609 1.625 0.73438 0.45703 0.59375 0.6875 1.5703 0.6875 2.9219 0 1.3555-0.23438 2.3281-0.70312 2.9219-0.38672 0.49219-0.92188 0.73438-1.6094 0.73438-0.69922 0-1.2617-0.26562-1.6875-0.79688-0.42969-0.53906-0.64062-1.5-0.64062-2.875 0-1.3438 0.23438-2.3125 0.70312-2.9062 0.38281-0.48828 0.92578-0.73438 1.625-0.73438zm0 1.1406c-0.16797 0-0.32031 0.054687-0.45312 0.15625-0.125 0.10547-0.22656 0.29297-0.29688 0.5625-0.09375 0.35547-0.14062 0.95312-0.14062 1.7969s0.039063 1.4219 0.125 1.7344c0.082031 0.3125 0.1875 0.52344 0.3125 0.625 0.13281 0.10547 0.28516 0.15625 0.45312 0.15625 0.16406 0 0.3125-0.050781 0.4375-0.15625 0.13281-0.10156 0.23438-0.29688 0.29688-0.57812 0.10156-0.34375 0.15625-0.9375 0.15625-1.7812s-0.046875-1.4219-0.14062-1.7344c-0.085938-0.3125-0.1875-0.51953-0.3125-0.625-0.125-0.10156-0.27344-0.15625-0.4375-0.15625z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.0625 0 1.8594-2.6719-1.7812-2.5156h1.6719l0.92188 1.4219 0.96875-1.4219h1.6094l-1.7656 2.4531 1.9219 2.7344h-1.6875l-1.0469-1.6094-1.0625 1.6094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.2344-3.6562-1.3438 0.25c-0.054687-0.26953-0.16406-0.47266-0.32812-0.60938-0.15625-0.13281-0.35938-0.20312-0.60938-0.20312-0.34375 0-0.62109 0.12109-0.82812 0.35938-0.19922 0.23047-0.29688 0.62109-0.29688 1.1719 0 0.61719 0.10156 1.0547 0.3125 1.3125 0.20703 0.25 0.48438 0.375 0.82812 0.375 0.25781 0 0.47266-0.070312 0.64062-0.21875 0.16406-0.15625 0.28125-0.41016 0.34375-0.76562l1.3594 0.21875c-0.14844 0.625-0.41797 1.1016-0.8125 1.4219-0.39844 0.3125-0.92969 0.46875-1.5938 0.46875-0.76172 0-1.3672-0.23828-1.8125-0.71875-0.44922-0.47656-0.67188-1.1445-0.67188-2 0-0.85156 0.22266-1.5156 0.67188-1.9844 0.44531-0.47656 1.0625-0.71875 1.8438-0.71875 0.625 0 1.125 0.13672 1.5 0.40625 0.375 0.27344 0.64062 0.68359 0.79688 1.2344z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.60938-5.1875h1.2656v0.70312c0.45703-0.53906 1-0.8125 1.625-0.8125 0.33203 0 0.61719 0.070313 0.85938 0.20312 0.25 0.13672 0.45312 0.33984 0.60938 0.60938 0.21875-0.26953 0.45703-0.47266 0.71875-0.60938 0.26953-0.13281 0.55469-0.20312 0.85938-0.20312 0.375 0 0.69141 0.078125 0.95312 0.23438 0.26953 0.14844 0.46875 0.37109 0.59375 0.67188 0.10156 0.21875 0.15625 0.57812 0.15625 1.0781v3.3125h-1.375v-2.9688c0-0.50781-0.046875-0.83594-0.14062-0.98438-0.13672-0.19531-0.33594-0.29688-0.59375-0.29688-0.1875 0-0.37109 0.058594-0.54688 0.17188-0.16797 0.11719-0.28906 0.28906-0.35938 0.51562-0.074219 0.23047-0.10938 0.58984-0.10938 1.0781v2.4844h-1.375v-2.8438c0-0.5-0.027344-0.82031-0.078125-0.96875-0.042969-0.14453-0.11719-0.25391-0.21875-0.32812-0.10547-0.070313-0.24609-0.10938-0.42188-0.10938-0.21094 0-0.40234 0.058594-0.57812 0.17188-0.16797 0.11719-0.28906 0.28125-0.35938 0.5-0.074219 0.21094-0.10938 0.5625-0.10938 1.0625v2.5156h-1.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.9375 0h-1.375v-5.1719c-0.5 0.46875-1.0898 0.82031-1.7656 1.0469v-1.25c0.35156-0.11328 0.73828-0.33203 1.1562-0.65625 0.42578-0.33203 0.71875-0.71875 0.875-1.1562h1.1094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.45312-1.6562 1.3281-0.14062c0.03125 0.27344 0.11328 0.47656 0.25 0.60938 0.13281 0.125 0.31641 0.1875 0.54688 0.1875 0.28125 0 0.51953-0.12891 0.71875-0.39062 0.19531-0.25781 0.32812-0.80078 0.39062-1.625-0.34375 0.39844-0.77734 0.59375-1.2969 0.59375-0.5625 0-1.0547-0.21094-1.4688-0.64062-0.40625-0.4375-0.60938-1.0039-0.60938-1.7031 0-0.72656 0.21094-1.3125 0.64062-1.75 0.4375-0.44531 0.98828-0.67188 1.6562-0.67188 0.72656 0 1.3203 0.28125 1.7812 0.84375 0.46875 0.5625 0.70312 1.4844 0.70312 2.7656 0 1.3125-0.24609 2.2617-0.73438 2.8438-0.48047 0.57422-1.1094 0.85938-1.8906 0.85938-0.55469 0-1.0078-0.14453-1.3594-0.4375-0.34375-0.30078-0.5625-0.75-0.65625-1.3438zm3.1094-3c0-0.4375-0.10547-0.77344-0.3125-1.0156-0.19922-0.25-0.43359-0.375-0.70312-0.375-0.25 0-0.46094 0.10156-0.625 0.29688-0.16797 0.19922-0.25 0.52734-0.25 0.98438 0 0.46094 0.085937 0.79688 0.26562 1.0156 0.1875 0.21875 0.41406 0.32812 0.6875 0.32812 0.25781 0 0.47656-0.10156 0.65625-0.3125 0.1875-0.20703 0.28125-0.51562 0.28125-0.92188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.71875 0v-1.375h1.375v1.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.71875-5.8906v-1.2656h1.375v1.2656zm0 5.8906v-5.1875h1.375v5.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-14-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.4375 0h-1.375v-2.6406c0-0.5625-0.03125-0.92578-0.09375-1.0938-0.054688-0.16406-0.14844-0.28906-0.28125-0.375-0.13672-0.09375-0.29297-0.14062-0.46875-0.14062-0.24219 0-0.45312 0.070312-0.64062 0.20312-0.1875 0.125-0.32031 0.29688-0.39062 0.51562-0.074219 0.21094-0.10938 0.60547-0.10938 1.1875v2.3438h-1.375v-5.1875h1.2812v0.76562c0.44531-0.58203 1.0156-0.875 1.7031-0.875 0.30078 0 0.57812 0.058594 0.82812 0.17188 0.25 0.10547 0.4375 0.24219 0.5625 0.40625 0.13281 0.16797 0.22656 0.35938 0.28125 0.57812 0.050781 0.21094 0.078125 0.51562 0.078125 0.92188z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.125-2.375h-0.8125v2.375h0.35938v-0.95312h0.45312c0.54688 0 0.84375-0.26562 0.84375-0.71875 0-0.4375-0.29688-0.70312-0.84375-0.70312zm-0.45312 1.1406v-0.85938h0.4375c0.3125 0 0.48438 0.125 0.48438 0.42188 0 0.3125-0.17188 0.4375-0.48438 0.4375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.32812-2.375v2.375h0.34375v-2.375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7969-0.28125h-1.125v-0.79688h1.0312v-0.28125h-1.0312v-0.73438h1.125v-0.28125h-1.4844v2.375h1.5v-0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.8906 0v-0.28125h-1.2656l1.2812-2.0469v-0.046875h-1.7031v0.28125h1.1875l-1.2812 2.0469v0.046875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2812-2.375h-0.3125l-0.70312 1.8125-0.21875 0.54688v0.015625h0.35938l0.015625-0.015625 0.1875-0.53125h1.0312l0.20312 0.53125v0.015625h0.375v-0.015625l-0.23438-0.57812zm0.26562 1.5625h-0.82812l0.40625-1.1094z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.20312-0.10938c0.10938 0.0625 0.32812 0.14062 0.625 0.14062 0.53125 0 0.84375-0.28125 0.84375-0.67188 0-0.3125-0.15625-0.53125-0.54688-0.6875l-0.26562-0.09375c-0.20312-0.078125-0.28125-0.17188-0.28125-0.34375 0-0.1875 0.14062-0.34375 0.45312-0.34375 0.25 0 0.4375 0.09375 0.53125 0.15625h0.015625v-0.34375c-0.09375-0.046875-0.28125-0.10938-0.5625-0.10938-0.48438 0-0.79688 0.28125-0.79688 0.65625 0 0.28125 0.15625 0.51562 0.5 0.64062l0.26562 0.10938c0.23438 0.078125 0.32812 0.20312 0.32812 0.375 0 0.1875-0.125 0.35938-0.46875 0.35938-0.28125 0-0.51562-0.10938-0.64062-0.1875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2812-2.0781c0.29688 0 0.48438 0.10938 0.57812 0.1875v-0.35938c-0.09375-0.078125-0.29688-0.14062-0.59375-0.14062-0.59375 0-1.0938 0.4375-1.0938 1.2031s0.5 1.2031 1.0938 1.2031c0.29688 0 0.5-0.0625 0.59375-0.14062v-0.35938c-0.09375 0.078125-0.28125 0.20312-0.57812 0.20312-0.40625 0-0.75-0.29688-0.75-0.90625s0.34375-0.89062 0.75-0.89062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.95312-3h-0.34375v0.015625l0.34375 0.4375h0.26562zm0.84375 2.7188h-1.125v-0.79688h1.0312v-0.28125h-1.0312v-0.73438h1.125v-0.28125h-1.4844v2.375h1.5v-0.28125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2344-2.4219c-0.64062 0-1.0625 0.5-1.0625 1.2344s0.42188 1.2344 1.0625 1.2344c0.65625 0 1.0781-0.5 1.0781-1.2344s-0.42188-1.2344-1.0781-1.2344zm0 2.1719c-0.46875 0-0.70312-0.40625-0.70312-0.9375s0.23438-0.9375 0.70312-0.9375 0.71875 0.40625 0.71875 0.9375-0.25 0.9375-0.71875 0.9375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.7812-2.3594v1.7656l-1.1406-1.7812h-0.32812v2.375h0.34375v-1.7812l1.125 1.7812h0.34375v-2.375h-0.34375z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6719-2.375h-1.6406v0.28125h0.64062v2.0938h0.35938v-2.0938h0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-18-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.39062 0.015625c0.10938 0 0.20312-0.078125 0.20312-0.20312s-0.09375-0.20312-0.20312-0.20312c-0.125 0-0.20312 0.078125-0.20312 0.20312s0.078125 0.20312 0.20312 0.20312z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-19-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.75-5.9844c-0.75 0-1.2812 0.17188-1.5312 0.29688h-0.015625l0.39062-3.2031h4.0781l0.10938-0.90625h-5.1094l-0.67188 5.4062h0.09375c0.375-0.26562 1.1875-0.64062 2.3438-0.64062 1.5156 0 2.3125 0.85938 2.3125 2.0156 0 1.2656-0.90625 2.1406-2.6094 2.1406-1.0938 0-1.9375-0.375-2.4062-0.70312h-0.046875v1.0938c0.40625 0.25 1.2656 0.5625 2.5469 0.5625 2.1562 0 3.6875-1.1562 3.6875-3.1094 0-1.8125-1.2812-2.9531-3.1719-2.9531z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-515.3 -397.75)",
    fill: "#171817"
  }, /*#__PURE__*/React.createElement("use", {
    x: 574.78998,
    y: 464.46677,
    xlinkHref: "#glyph-0-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 577.65833,
    y: 464.46677,
    xlinkHref: "#glyph-0-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 580.52667,
    y: 464.46677,
    xlinkHref: "#glyph-0-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 583.39502,
    y: 464.46677,
    xlinkHref: "#glyph-0-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 586.26337,
    y: 464.46677,
    xlinkHref: "#glyph-0-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 589.13171,
    y: 464.46677,
    xlinkHref: "#glyph-0-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 592.00006,
    y: 464.46677,
    xlinkHref: "#glyph-0-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 594.86847,
    y: 464.46677,
    xlinkHref: "#glyph-0-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 597.73682,
    y: 464.46677,
    xlinkHref: "#glyph-0-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600.60516,
    y: 464.46677,
    xlinkHref: "#glyph-0-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 603.47351,
    y: 464.46677,
    xlinkHref: "#glyph-0-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 606.34186,
    y: 464.46677,
    xlinkHref: "#glyph-0-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 609.21021,
    y: 464.46677,
    xlinkHref: "#glyph-0-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 612.07855,
    y: 464.46677,
    xlinkHref: "#glyph-0-4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.059 62.734h97.492v-21.934h-97.492z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#0e0f0e"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40.652 60.176h0.57031v-16.82h-0.57031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.953 60.176h0.57031v-16.82h-0.57031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.254 60.176h0.57031v-16.82h-0.57031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.555 60.176h0.57031v-16.82h-0.57031z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m46.832 60.176h1.5469v-16.82h-1.5469z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.109 60.176h0.56641v-16.82h-0.56641z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.41 60.176h1.543v-16.82h-1.543z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.664 60.176h0.5664v-16.82h-0.5664z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.965 60.176h1.543v-16.82h-1.543z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.238 60.176h0.57031v-16.82h-0.57031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.516 60.176h1.5469v-16.82h-1.5469z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.793 60.176h0.57032v-16.82h-0.57032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.07 60.176h1.543v-16.82h-1.543z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.348 60.176h0.56641v-16.82h-0.56641z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.648 60.176h0.57031v-16.82h-0.57031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.867 60.176h1.6289v-16.82h-1.6289z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.199 60.176h0.57032v-16.82h-0.57032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.395 60.176h0.65234v-16.82h-0.65234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.699 60.176h1.625v-16.82h-1.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.949 60.176h1.625v-16.82h-1.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m81.227 60.176h0.65234v-16.82h-0.65234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.527 60.176h0.64844v-16.82h-0.64844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.805 60.176h0.65235v-16.82h-0.65235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.082 60.176h0.64843v-16.82h-0.64843z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m88.383 60.176h1.625v-16.82h-1.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.633 60.176h1.6289v-16.82h-1.6289z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.91 60.176h0.65234v-16.82h-0.65234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.211 60.176h0.65235v-16.82h-0.65235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.512 60.176h1.6289v-16.82h-1.6289z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.766 60.176h0.65234v-16.82h-0.65234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.07 60.176h0.65234v-16.82h-0.65234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.34 60.176h1.625v-16.82h-1.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.62 60.176h0.64844v-16.82h-0.64844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.92 60.176h1.625v-16.82h-1.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.2 60.176h0.65234v-16.82h-0.65234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.5 60.176h1.625v-16.82h-1.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.75 60.176h0.65235v-16.82h-0.65235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.03 60.176h1.625v-16.82h-1.625z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.3 60.176h0.65235v-16.82h-0.65235z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m127.81 176v-0.25h-127.31v-175.25h127.06v175.5h0.25v-0.25 0.25h0.25v-176h-128.06v176.25h128.06v-0.25zm-59.531-160.16h-0.25c0 1.1055-0.44531 2.1055-1.1719 2.8281-0.72266 0.72656-1.7227 1.1758-2.8281 1.1758-1.1055 0-2.1055-0.44922-2.832-1.1758-0.72265-0.72266-1.1719-1.7227-1.1719-2.8281s0.44922-2.1055 1.1719-2.8281c0.72657-0.72656 1.7266-1.1719 2.832-1.1719 1.1055 0 2.1055 0.44532 2.8281 1.1719 0.72656 0.72265 1.1719 1.7226 1.1719 2.8281h0.5c0-2.4844-2.0156-4.5-4.5-4.5-2.4883 0-4.5039 2.0156-4.5039 4.5 0 2.4844 2.0156 4.5039 4.5039 4.5039 2.4844 0 4.5-2.0195 4.5-4.5039",
    fill: "#4f5257"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#171817"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-515.3 -397.75)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 524.76898,
    y: 475.57901,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 526.72797,
    y: 475.57901,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528.86273,
    y: 475.57901,
    xlinkHref: "#glyph-4-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 530.15375,
    y: 475.57901,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 530.78149,
    y: 475.57901,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 533.48749,
    y: 475.57901,
    xlinkHref: "#glyph-4-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 535.46313,
    y: 475.57901,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 537.19049,
    y: 475.57901,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 539.14948,
    y: 475.57901,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.29205,
    y: 475.57901,
    xlinkHref: "#glyph-4-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 543.36792,
    y: 475.57901,
    xlinkHref: "#glyph-4-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 544.95026,
    y: 475.57901,
    xlinkHref: "#glyph-4-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 546.55573,
    y: 475.57901,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 547.18463,
    y: 475.57901,
    xlinkHref: "#glyph-4-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 548.90808,
    y: 475.57901,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 551.7821,
    y: 475.57901,
    xlinkHref: "#glyph-4-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 553.15466,
    y: 475.57901,
    xlinkHref: "#glyph-4-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 554.98236,
    y: 475.57901,
    xlinkHref: "#glyph-4-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 556.42767,
    y: 475.57901,
    xlinkHref: "#glyph-4-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 558.737,
    y: 475.57901,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 560.87958,
    y: 475.57901,
    xlinkHref: "#glyph-4-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 562.3418,
    y: 475.57901,
    xlinkHref: "#glyph-4-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 564.16284,
    y: 475.57901,
    xlinkHref: "#glyph-4-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 566.06836,
    y: 475.57901,
    xlinkHref: "#glyph-4-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 568.61084,
    y: 475.57901,
    xlinkHref: "#glyph-4-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 570.5874,
    y: 475.57901,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 572.31396,
    y: 475.57901,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 574.27295,
    y: 475.57901,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576.41553,
    y: 475.57901,
    xlinkHref: "#glyph-4-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 578.49103,
    y: 475.57901,
    xlinkHref: "#glyph-4-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 580.07452,
    y: 475.57901,
    xlinkHref: "#glyph-4-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 581.67883,
    y: 475.57901,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 582.30853,
    y: 475.57901,
    xlinkHref: "#glyph-4-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 583.95941,
    y: 475.57901,
    xlinkHref: "#glyph-4-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 586.50195,
    y: 475.57901,
    xlinkHref: "#glyph-4-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 587.87592,
    y: 475.57901,
    xlinkHref: "#glyph-4-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 589.85156,
    y: 475.57901,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 591.57928,
    y: 475.57901,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 593.53711,
    y: 475.57901,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 595.68085,
    y: 475.57901,
    xlinkHref: "#glyph-4-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 597.75635,
    y: 475.57901,
    xlinkHref: "#glyph-4-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 599.33868,
    y: 475.57901,
    xlinkHref: "#glyph-4-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600.94336,
    y: 475.57901,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 601.57306,
    y: 475.57901,
    xlinkHref: "#glyph-4-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 603.38483,
    y: 475.57901,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 605.92535,
    y: 475.57901,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 607.87219,
    y: 475.57901,
    xlinkHref: "#glyph-4-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 609.8175,
    y: 475.57901,
    xlinkHref: "#glyph-4-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 611.61633,
    y: 475.57901,
    xlinkHref: "#glyph-4-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 613.57532,
    y: 475.57901,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 614.20306,
    y: 475.57901,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 616.3476,
    y: 475.57901,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 619.05359,
    y: 475.57901,
    xlinkHref: "#glyph-4-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 620.42761,
    y: 475.57901,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 622.38666,
    y: 475.57901,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624.52063,
    y: 475.57901,
    xlinkHref: "#glyph-4-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 626.46594,
    y: 475.57901,
    xlinkHref: "#glyph-4-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 628.26404,
    y: 475.57901,
    xlinkHref: "#glyph-4-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 630.04608,
    y: 475.57901,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 630.67383,
    y: 475.57901,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 632.83984,
    y: 475.57901,
    xlinkHref: "#glyph-4-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 524.76898,
    y: 479.57745,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 526.74561,
    y: 479.57745,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528.4646,
    y: 479.57745,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 529.03583,
    y: 479.57745,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 531.01239,
    y: 479.57745,
    xlinkHref: "#glyph-5-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 532.74011,
    y: 479.57745,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 534.69794,
    y: 479.57745,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 536.84052,
    y: 479.57745,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 538.9187,
    y: 479.57745,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 540.49951,
    y: 479.57745,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 542.10425,
    y: 479.57745,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 542.73199,
    y: 479.57745,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 544.87653,
    y: 479.57745,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 546.7605,
    y: 479.57745,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 547.3316,
    y: 479.57745,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 547.88361,
    y: 479.57745,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 548.45581,
    y: 479.57745,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 550.23822,
    y: 479.57745,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 550.86517,
    y: 479.57745,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552.62573,
    y: 479.57745,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 554.60352,
    y: 479.57745,
    xlinkHref: "#glyph-5-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 556.40234,
    y: 479.57745,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 558.34766,
    y: 479.57745,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 560.14453,
    y: 479.57745,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 561.94531,
    y: 479.57745,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 563.70587,
    y: 479.57745,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 565.58984,
    y: 479.57745,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 566.16211,
    y: 479.57745,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 566.71411,
    y: 479.57745,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 567.28632,
    y: 479.57745,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 569.23322,
    y: 479.57745,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 571.17859,
    y: 479.57745,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 572.95276,
    y: 479.57745,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 574.89539,
    y: 479.57745,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 575.52313,
    y: 479.57745,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 577.49463,
    y: 479.57745,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 579.54663,
    y: 479.57745,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 580.11804,
    y: 479.57745,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 582.0946,
    y: 479.57745,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 583.82117,
    y: 479.57745,
    xlinkHref: "#glyph-5-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 585.78021,
    y: 479.57745,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 587.92273,
    y: 479.57745,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 590.00012,
    y: 479.57745,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 591.58215,
    y: 479.57745,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 593.18646,
    y: 479.57745,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 593.81653,
    y: 479.57745,
    xlinkHref: "#glyph-5-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 595.53918,
    y: 479.57745,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 597.59119,
    y: 479.57745,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 598.16339,
    y: 479.57745,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 599.28607,
    y: 479.57745,
    xlinkHref: "#glyph-5-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600.88373,
    y: 479.57745,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 601.51147,
    y: 479.57745,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 603.27124,
    y: 479.57745,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 605.24902,
    y: 479.57745,
    xlinkHref: "#glyph-5-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 607.05096,
    y: 479.57745,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 607.6709,
    y: 479.57745,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 609.46893,
    y: 479.57745,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 611.26825,
    y: 479.57745,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 613.02997,
    y: 479.57745,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 614.91394,
    y: 479.57745,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 615.48621,
    y: 479.57745,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 616.03821,
    y: 479.57745,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 616.60925,
    y: 479.57745,
    xlinkHref: "#glyph-5-17"
  }), /*#__PURE__*/React.createElement("use", {
    x: 618.4483,
    y: 479.57745,
    xlinkHref: "#glyph-5-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 619.08582,
    y: 479.57745,
    xlinkHref: "#glyph-5-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 620.91394,
    y: 479.57745,
    xlinkHref: "#glyph-5-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 622.5788,
    y: 479.57745,
    xlinkHref: "#glyph-5-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624.61591,
    y: 479.57745,
    xlinkHref: "#glyph-5-22"
  }), /*#__PURE__*/React.createElement("use", {
    x: 626.18036,
    y: 479.57745,
    xlinkHref: "#glyph-5-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 628.44794,
    y: 479.57745,
    xlinkHref: "#glyph-5-24"
  }), /*#__PURE__*/React.createElement("use", {
    x: 630.40302,
    y: 479.57745,
    xlinkHref: "#glyph-5-25"
  }), /*#__PURE__*/React.createElement("use", {
    x: 632.00732,
    y: 479.57745,
    xlinkHref: "#glyph-5-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 524.76898,
    y: 483.57626,
    xlinkHref: "#glyph-5-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 526.43384,
    y: 483.57626,
    xlinkHref: "#glyph-5-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528.48584,
    y: 483.57626,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 530.7807,
    y: 483.57626,
    xlinkHref: "#glyph-5-23"
  }), /*#__PURE__*/React.createElement("use", {
    x: 533.10297,
    y: 483.57626,
    xlinkHref: "#glyph-5-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 534.95807,
    y: 483.57626,
    xlinkHref: "#glyph-5-26"
  }), /*#__PURE__*/React.createElement("use", {
    x: 536.63971,
    y: 483.57626,
    xlinkHref: "#glyph-5-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 537.27057,
    y: 483.57626,
    xlinkHref: "#glyph-5-27"
  }), /*#__PURE__*/React.createElement("use", {
    x: 539.18854,
    y: 483.57626,
    xlinkHref: "#glyph-5-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.0116,
    y: 483.57626,
    xlinkHref: "#glyph-5-28"
  }), /*#__PURE__*/React.createElement("use", {
    x: 542.75574,
    y: 483.57626,
    xlinkHref: "#glyph-5-18"
  }), /*#__PURE__*/React.createElement("use", {
    x: 543.30774,
    y: 483.57626,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 545.60376,
    y: 483.57626,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 546.15576,
    y: 483.57626,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 548.45178,
    y: 483.57626,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 550.42841,
    y: 483.57626,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552.19794,
    y: 483.57626,
    xlinkHref: "#glyph-5-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 553.88464,
    y: 483.57626,
    xlinkHref: "#glyph-5-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 556.02802,
    y: 483.57626,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 558.10498,
    y: 483.57626,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 559.68585,
    y: 483.57626,
    xlinkHref: "#glyph-5-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 561.29053,
    y: 483.57626,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 561.92023,
    y: 483.57626,
    xlinkHref: "#glyph-5-15"
  }), /*#__PURE__*/React.createElement("use", {
    x: 563.63922,
    y: 483.57626,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 565.9339,
    y: 483.57626,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 567.69562,
    y: 483.57626,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 569.66516,
    y: 483.57626,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 571.64172,
    y: 483.57626,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 573.36072,
    y: 483.57626,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 575.65662,
    y: 483.57626,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576.20862,
    y: 483.57626,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 578.50464,
    y: 483.57626,
    xlinkHref: "#glyph-5-30"
  }), /*#__PURE__*/React.createElement("use", {
    x: 581.21045,
    y: 483.57626,
    xlinkHref: "#glyph-5-31"
  }), /*#__PURE__*/React.createElement("use", {
    x: 583.72491,
    y: 483.57626,
    xlinkHref: "#glyph-5-32"
  }), /*#__PURE__*/React.createElement("use", {
    x: 586.36554,
    y: 483.57626,
    xlinkHref: "#glyph-5-33"
  }), /*#__PURE__*/React.createElement("use", {
    x: 589.05377,
    y: 483.57626,
    xlinkHref: "#glyph-5-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 591.49634,
    y: 483.57626,
    xlinkHref: "#glyph-5-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 593.86621,
    y: 483.57626,
    xlinkHref: "#glyph-5-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 596.43652,
    y: 483.57626,
    xlinkHref: "#glyph-5-37"
  }), /*#__PURE__*/React.createElement("use", {
    x: 598.9068,
    y: 483.57626,
    xlinkHref: "#glyph-5-38"
  }), /*#__PURE__*/React.createElement("use", {
    x: 601.35132,
    y: 483.57626,
    xlinkHref: "#glyph-5-34"
  }), /*#__PURE__*/React.createElement("use", {
    x: 603.79352,
    y: 483.57626,
    xlinkHref: "#glyph-5-35"
  }), /*#__PURE__*/React.createElement("use", {
    x: 606.16382,
    y: 483.57626,
    xlinkHref: "#glyph-5-36"
  }), /*#__PURE__*/React.createElement("use", {
    x: 608.88177,
    y: 483.57626,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 611.17786,
    y: 483.57626,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 611.72986,
    y: 483.57626,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 614.02472,
    y: 483.57626,
    xlinkHref: "#glyph-5-39"
  }), /*#__PURE__*/React.createElement("use", {
    x: 616.5528,
    y: 483.57626,
    xlinkHref: "#glyph-5-40"
  }), /*#__PURE__*/React.createElement("use", {
    x: 619.24615,
    y: 483.57626,
    xlinkHref: "#glyph-5-41"
  }), /*#__PURE__*/React.createElement("use", {
    x: 621.96417,
    y: 483.57626,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624.26019,
    y: 483.57626,
    xlinkHref: "#glyph-5-42"
  }), /*#__PURE__*/React.createElement("use", {
    x: 626.99573,
    y: 483.57626,
    xlinkHref: "#glyph-5-43"
  }), /*#__PURE__*/React.createElement("use", {
    x: 629.71375,
    y: 483.57626,
    xlinkHref: "#glyph-5-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 632.00861,
    y: 483.57626,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 524.76898,
    y: 487.57471,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 526.52881,
    y: 487.57471,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528.42017,
    y: 487.57471,
    xlinkHref: "#glyph-5-44"
  }), /*#__PURE__*/React.createElement("use", {
    x: 530.22919,
    y: 487.57471,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 532.2049,
    y: 487.57471,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 534.19122,
    y: 487.57471,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 536.00958,
    y: 487.57471,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 537.9588,
    y: 487.57471,
    xlinkHref: "#glyph-5-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 539.76776,
    y: 487.57471,
    xlinkHref: "#glyph-5-13"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.56659,
    y: 487.57471,
    xlinkHref: "#glyph-5-14"
  }), /*#__PURE__*/React.createElement("use", {
    x: 543.53607,
    y: 487.57471,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 545.51007,
    y: 487.57471,
    xlinkHref: "#glyph-5-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 547.48688,
    y: 487.57471,
    xlinkHref: "#glyph-5-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 550.0033,
    y: 487.57471,
    xlinkHref: "#glyph-5-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 551.07288,
    y: 487.57471,
    xlinkHref: "#glyph-5-45"
  }), /*#__PURE__*/React.createElement("use", {
    x: 552.50391,
    y: 487.57471,
    xlinkHref: "#glyph-5-99"
  }), /*#__PURE__*/React.createElement("use", {
    x: 553.34088,
    y: 487.57471,
    xlinkHref: "#glyph-5-99"
  }), /*#__PURE__*/React.createElement("use", {
    x: 554.17792,
    y: 487.57471,
    xlinkHref: "#glyph-5-46"
  }), /*#__PURE__*/React.createElement("use", {
    x: 554.90692,
    y: 487.57471,
    xlinkHref: "#glyph-5-47"
  }), /*#__PURE__*/React.createElement("use", {
    x: 555.63593,
    y: 487.57471,
    xlinkHref: "#glyph-5-46"
  }), /*#__PURE__*/React.createElement("use", {
    x: 556.36493,
    y: 487.57471,
    xlinkHref: "#glyph-5-48"
  }), /*#__PURE__*/React.createElement("use", {
    x: 557.1264,
    y: 487.57471,
    xlinkHref: "#glyph-5-49"
  }), /*#__PURE__*/React.createElement("use", {
    x: 558.43439,
    y: 487.57471,
    xlinkHref: "#glyph-5-50"
  }), /*#__PURE__*/React.createElement("use", {
    x: 559.77802,
    y: 487.57471,
    xlinkHref: "#glyph-5-51"
  }), /*#__PURE__*/React.createElement("use", {
    x: 561.09637,
    y: 487.57471,
    xlinkHref: "#glyph-5-52"
  }), /*#__PURE__*/React.createElement("use", {
    x: 562.12292,
    y: 487.57471,
    xlinkHref: "#glyph-5-53"
  }), /*#__PURE__*/React.createElement("use", {
    x: 562.94196,
    y: 487.57471,
    xlinkHref: "#glyph-5-99"
  }), /*#__PURE__*/React.createElement("use", {
    x: 563.77893,
    y: 487.57471,
    xlinkHref: "#glyph-5-99"
  }), /*#__PURE__*/React.createElement("use", {
    x: 564.61591,
    y: 487.57471,
    xlinkHref: "#glyph-5-54"
  }), /*#__PURE__*/React.createElement("use", {
    x: 566.65961,
    y: 487.57471,
    xlinkHref: "#glyph-5-55"
  }), /*#__PURE__*/React.createElement("use", {
    x: 568.8678,
    y: 487.57471,
    xlinkHref: "#glyph-4-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 570.21783,
    y: 487.57471,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 572.17609,
    y: 487.57471,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 574.20343,
    y: 487.57471,
    xlinkHref: "#glyph-4-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576.00031,
    y: 487.57471,
    xlinkHref: "#glyph-4-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576.63318,
    y: 487.57471,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 579.31512,
    y: 487.57471,
    xlinkHref: "#glyph-4-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 581.29175,
    y: 487.57471,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 583.0191,
    y: 487.57471,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 584.97729,
    y: 487.57471,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 587.11987,
    y: 487.57471,
    xlinkHref: "#glyph-4-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 589.19653,
    y: 487.57471,
    xlinkHref: "#glyph-4-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 590.77887,
    y: 487.57471,
    xlinkHref: "#glyph-4-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 592.38318,
    y: 487.57471,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 593.01324,
    y: 487.57471,
    xlinkHref: "#glyph-4-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 594.73669,
    y: 487.57471,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 597.58673,
    y: 487.57471,
    xlinkHref: "#glyph-4-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 598.93677,
    y: 487.57471,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600.89575,
    y: 487.57471,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 603.02155,
    y: 487.57471,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 603.6532,
    y: 487.57471,
    xlinkHref: "#glyph-4-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 605.44934,
    y: 487.57471,
    xlinkHref: "#glyph-4-20"
  }), /*#__PURE__*/React.createElement("use", {
    x: 606.79938,
    y: 487.57471,
    xlinkHref: "#glyph-4-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 608.77515,
    y: 487.57471,
    xlinkHref: "#glyph-4-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 610.5025,
    y: 487.57471,
    xlinkHref: "#glyph-4-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 612.46069,
    y: 487.57471,
    xlinkHref: "#glyph-4-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 614.60406,
    y: 487.57471,
    xlinkHref: "#glyph-4-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 616.6795,
    y: 487.57471,
    xlinkHref: "#glyph-4-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 618.26227,
    y: 487.57471,
    xlinkHref: "#glyph-4-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 619.86652,
    y: 487.57471,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 620.49158,
    y: 487.57471,
    xlinkHref: "#glyph-4-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 623.17352,
    y: 487.57471,
    xlinkHref: "#glyph-4-12"
  }), /*#__PURE__*/React.createElement("use", {
    x: 624.52356,
    y: 487.57471,
    xlinkHref: "#glyph-4-21"
  }), /*#__PURE__*/React.createElement("use", {
    x: 626.32251,
    y: 487.57471,
    xlinkHref: "#glyph-4-16"
  }), /*#__PURE__*/React.createElement("use", {
    x: 628.25684,
    y: 487.57471,
    xlinkHref: "#glyph-4-19"
  }), /*#__PURE__*/React.createElement("use", {
    x: 630.05255,
    y: 487.57471,
    xlinkHref: "#glyph-4-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 630.6803,
    y: 487.57471,
    xlinkHref: "#glyph-4-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 632.84631,
    y: 487.57471,
    xlinkHref: "#glyph-4-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 524.76898,
    y: 491.57315,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 526.59241,
    y: 491.57315,
    xlinkHref: "#glyph-5-29"
  }), /*#__PURE__*/React.createElement("use", {
    x: 528.23499,
    y: 491.57315,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 530.03967,
    y: 491.57315,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 530.66663,
    y: 491.57315,
    xlinkHref: "#glyph-5-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 532.63165,
    y: 491.57315,
    xlinkHref: "#glyph-5-58"
  }), /*#__PURE__*/React.createElement("use", {
    x: 534.76465,
    y: 491.57315,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 536.58307,
    y: 491.57315,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 538.55182,
    y: 491.57315,
    xlinkHref: "#glyph-5-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 540.50494,
    y: 491.57315,
    xlinkHref: "#glyph-5-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 541.14246,
    y: 491.57315,
    xlinkHref: "#glyph-5-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 525.42102,
    y: 525.87628,
    xlinkHref: "#glyph-14-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 531.17413,
    y: 525.87628,
    xlinkHref: "#glyph-14-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 536.83698,
    y: 525.87628,
    xlinkHref: "#glyph-14-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 542.31787,
    y: 525.87628,
    xlinkHref: "#glyph-14-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 548.06976,
    y: 525.87628,
    xlinkHref: "#glyph-14-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 553.62976,
    y: 525.87628,
    xlinkHref: "#glyph-14-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 556.40979,
    y: 525.87628,
    xlinkHref: "#glyph-14-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 562.10492,
    y: 525.87628,
    xlinkHref: "#glyph-14-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 570.99493,
    y: 525.87628,
    xlinkHref: "#glyph-14-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 573.77496,
    y: 525.87628,
    xlinkHref: "#glyph-14-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576.55493,
    y: 525.87628,
    xlinkHref: "#glyph-14-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 581.85608,
    y: 525.87628,
    xlinkHref: "#glyph-14-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 587.35803,
    y: 525.87628,
    xlinkHref: "#glyph-14-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 590.24323,
    y: 525.87628,
    xlinkHref: "#glyph-14-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 595.776,
    y: 525.87628,
    xlinkHref: "#glyph-14-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 601.30103,
    y: 525.87628,
    xlinkHref: "#glyph-14-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 606.60413,
    y: 525.87628,
    xlinkHref: "#glyph-14-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 612.10608,
    y: 525.87628,
    xlinkHref: "#glyph-14-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 614.99127,
    y: 525.87628,
    xlinkHref: "#glyph-14-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 620.55127,
    y: 525.87628,
    xlinkHref: "#glyph-14-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 623.33124,
    y: 525.87628,
    xlinkHref: "#glyph-14-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 626.15845,
    y: 525.87628,
    xlinkHref: "#glyph-14-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 632.34045,
    y: 525.87628,
    xlinkHref: "#glyph-14-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 635.12042,
    y: 525.87628,
    xlinkHref: "#glyph-14-3"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m99.574 9.7813c0.20313 0.0391 0.40625 0.0742 0.60938 0.11719 0.96875 0.20703 1.8125 0.65234 2.5156 1.3555l0.0312 0.0273c0.3125-0.30469 0.6211-0.60938 0.9336-0.91797l0.0273 0.0234c-0.0156 0.94922-0.0273 1.8906-0.0469 2.8438-0.94141-0.0156-1.8867-0.0274-2.8359-0.0469 0.32812-0.3125 0.65234-0.62109 0.98828-0.94531-0.14063-0.11719-0.23828-0.21484-0.34766-0.29687-0.76562-0.59375-1.6406-0.83985-2.5977-0.82422-1.4922 0.0195-2.7812 0.59375-3.9492 1.4688-0.52344 0.39843-0.98828 0.85547-1.3984 1.3672l-0.0703 0.0781c-0.32031-0.33203-0.63281-0.66406-0.95703-1l0.10156-0.125c0.98437-1.125 2.1328-2.0273 3.5273-2.5859 0.67578-0.26953 1.3789-0.44531 2.1055-0.53125l0.23047-0.0273c0.375 4e-3 0.75391 0.0117 1.1328 0.0195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.66 17.234c0.0234-0.125 0.0469-0.25 0.0703-0.38671l0.0781 0.0742c0.375 0.39063 0.74609 0.77735 1.1172 1.1758l0.0742 0.17578c0.0273 0.16797 0.043 0.34375 0.0703 0.55078l-0.10547-0.10156c-0.40625-0.41797-0.8125-0.83985-1.2148-1.2539l-0.0937-0.0781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.12 15.598c-0.0234 0.125-0.0469 0.24218-0.0703 0.38281l-0.0859-0.0781c-0.35937-0.37109-0.72265-0.74609-1.0781-1.1211l-0.082-0.18359c-0.0274-0.15235-0.0352-0.3086-0.0586-0.4961l0.10156 0.10547c0.39454 0.40625 0.78907 0.81641 1.1836 1.2266l0.0898 0.0742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.125 14.258c-8e-3 0.38281-0.0156 0.7461-0.0195 1.1211 0.1875-0.0117 0.35938-0.0195 0.54688-0.0274 4e-3 -0.36328 0.0117-0.71875 0.0156-1.082-0.18359-4e-3 -0.36328-8e-3 -0.54297-0.0117m-2.8906-1.3828c0.23828 0.12891 0.46484 0.25 0.69531 0.36719l0.0274 0.0312c-0.25 0.36718-0.5 0.73047-0.75 1.1016 0.0976 0.11328 0.19531 0.22656 0.29687 0.34766 0.21094-0.34375 0.41406-0.6836 0.625-1.0352 0.25781 0.12109 0.51172 0.23828 0.77734 0.36328-0.4375 0.58594-0.875 1.1641-1.3242 1.7734 0.19531-0.0117 0.375-0.0195 0.5664-0.0274-0.0312-0.1289-0.0625-0.2539-0.0937-0.3789 0.21485-0.0625 0.42188-0.11719 0.64063-0.17578 0.14062 0.36718 0.27734 0.73047 0.41797 1.0938l0.0234-8e-3c0.0156-0.99218 0.0312-1.9922 0.0469-2.9922 0.27734-0.0156 0.53906-0.0234 0.80078-0.0352 0.73828-0.0312 1.4688-0.12891 2.1953-0.26953l0.10938 0.0469c0.10937 0.32032 0.22656 0.64454 0.34375 0.98438-0.10938 0.0234-0.21094 0.0508-0.3125 0.0664-0.19141 0.0234-0.37891 0.043-0.56641 0.0625l-0.10156 0.082c-0.0156 0.35937-0.0391 0.71875-0.0586 1.0781l0.0117 0.0469c0.33594-8e-3 0.67578-0.0156 1.0274-0.0274-4e-3 0.32813-8e-3 0.65235-0.0156 1.0039-0.33594-8e-3 -0.67578-0.0117-1.0391-0.0195 0.0273 0.32812 0.0469 0.625 0.0898 0.92187 0.0312 0.23828 0.0859 0.48047 0.14063 0.71875l0.11719 0.1875 0.16015-0.16015c0.0664-0.12891 0.1211-0.26563 0.1875-0.41016l0.0391 0.0859c0.11329 0.27344 0.22657 0.54297 0.33985 0.80859l0.0312 0.25391c-0.0586 0.25-0.14063 0.48047-0.28125 0.6914-0.27344 0.41016-0.71875 0.44532-1.0625 0.082-0.25391-0.26954-0.38281-0.60938-0.42969-0.96875-0.0898-0.6875-0.14844-1.3789-0.21875-2.0664l-0.0195-0.19531c-0.19531 0-0.38281-4e-3 -0.58203-8e-3 -0.0117 0.6836-0.0234 1.3672-0.0312 2.0586 0.21875-0.0391 0.42187-0.0781 0.64062-0.11719 8e-3 0.34766 0.0156 0.6875 0.0234 1.0391-0.70703 0.12891-1.3984 0.26172-2.1133 0.39453 4e-3 -0.32421 8e-3 -0.64062 0.0156-0.96875-0.12109 0.0195-0.21875 0.0312-0.32031 0.043-0.0586-0.53906-0.11719-1.0742-0.17578-1.625 0.1875-0.0234 0.375-0.0469 0.57031-0.0742 0.082 0.48047 0.16407 0.94922 0.25 1.4297l0.15235-8e-3c8e-3 -0.5625 0.0156-1.1211 0.0273-1.6992-0.23437 0.0508-0.45703 0.0937-0.6875 0.14063l-0.0781-0.23047c-0.1211 0.0117-0.24219 0.0312-0.38282 0.043-0.0156 0.98828-0.0312 1.9726-0.0469 2.9688-0.31641-4e-3 -0.60938-0.0117-0.90625-0.0117 0.0117-0.96094 0.0273-1.918 0.043-2.8906-0.34375 0.0156-0.67969 0.0312-1.043 0.043 8e-3 -0.32422 0.0117-0.63281 0.0156-0.96875 0.1211 0 0.25391 8e-3 0.38282 4e-3l0.14843-0.0703c0.10157-0.0937 0.1875-0.19531 0.28516-0.30468-0.29688-0.32032-0.58203-0.64063-0.88281-0.96485 0.16406-0.26562 0.32812-0.53125 0.5-0.80859l0.19531 0.11328c0.18359-0.31641 0.37109-0.63281 0.5625-0.95703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.37 18.836c0.3086 0.33593 0.60547 0.65625 0.91797 1-0.19531 0.20703-0.39844 0.44531-0.61719 0.66797-0.99609 1.0078-2.1563 1.7578-3.5039 2.2031-0.6211 0.20703-1.2617 0.32813-1.9141 0.36719-1.0508 0.0625-2.043-0.125-2.9805-0.60156-0.42579-0.21875-0.8086-0.5-1.1484-0.83204l-0.0977-0.0937c-0.30859 0.29688-0.61328 0.59375-0.93359 0.90235 0.0156-0.95703 0.0312-1.8945 0.0469-2.8438 0.94532 0.0156 1.8906 0.0273 2.8281 0.043-0.32031 0.3164-0.64453 0.6289-0.97656 0.94922 0.25781 0.26953 0.52343 0.47656 0.82421 0.64453 0.7461 0.41797 1.5586 0.5664 2.4024 0.49609 1.8633-0.14453 3.3711-1.0117 4.6484-2.332 0.16796-0.17969 0.32421-0.36719 0.5039-0.57031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.598 19.254c-0.23047-0.14063-0.44141-0.27344-0.64844-0.40625l-0.0351-0.0899c0.15234-0.53125 0.17578-1.0859 0.24218-1.6367l0.10938-0.0859c0.19141 0.0234 0.38281 0.0351 0.58203 0.0508 0.0117 0.73437-0.0391 1.4453-0.25 2.168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.773 15.023c-0.33203-0.33203-0.66015-0.66407-0.99609-0.9961 0.17187-0.25781 0.34375-0.50781 0.52344-0.76953 0.3164 0.33985 0.6289 0.67188 0.94531 1.0156-0.16016 0.2539-0.32031 0.51172-0.47266 0.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.01 17.871c0.32812 0.32032 0.64843 0.64453 0.97265 0.96875-0.17187 0.2461-0.34375 0.48828-0.5039 0.71875-0.3086-0.3125-0.61719-0.625-0.9336-0.9414 0.15625-0.25 0.3125-0.50391 0.46485-0.7461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.309 16.078c-0.19922-0.20312-0.38672-0.39062-0.57813-0.58203-0.13281-0.14062-0.26562-0.27734-0.39843-0.42187l-0.0274-0.0977c0.0937-0.21094 0.19922-0.41406 0.30469-0.6289l0.0781 0.0742c0.28516 0.29688 0.57032 0.59766 0.85547 0.89063l0.0274 0.15625c-0.0937 0.19922-0.17578 0.40234-0.26172 0.60937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.16 18.52c-0.19531-0.19531-0.38281-0.38672-0.57031-0.57422-0.11719-0.11719-0.23828-0.23828-0.35156-0.36719l-0.0312-0.11328c0.0859-0.22656 0.17968-0.44531 0.27734-0.67578l0.0977 0.10547c0.27343 0.30859 0.55078 0.61719 0.83203 0.92188l0.0195 0.16406c-0.0937 0.17578-0.1836 0.35937-0.27344 0.53906"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.027 17.27c-0.37891-0.38672-0.7461-0.75781-1.1094-1.1289l-0.0195-0.0898c0.0469-0.15625 0.0977-0.31641 0.14844-0.47266l0.0391-0.0312 0.0899 0.14063c0.29687 0.30469 0.59765 0.60937 0.89453 0.91406l0.0508 0.17578c-0.0391 0.16016-0.0625 0.32813-0.0937 0.49219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.78 15.621 0.082 0.0781c0.32422 0.33594 0.64062 0.67187 0.96094 1.0078l0.0351 0.15625c-0.0586 0.14844-0.10547 0.29297-0.15625 0.45703l-0.0859-0.0859c-0.29688-0.32031-0.58594-0.63671-0.88282-0.96093l-0.0469-0.17578c0.0352-0.15235 0.0625-0.3086 0.0937-0.47657"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m109.98 22.09c-2.1406-1.0898-3.4688-3.2617-3.4688-5.6641 0-2.3008 1.2461-4.4258 3.25-5.5469 0.11328-0.0664 0.23047-0.125 0.23047-0.125l0.38281 0.75781-0.19921 0.10547c-1.7383 0.97265-2.8203 2.8164-2.8203 4.8086 0 2.082 1.1524 3.9648 3.0117 4.9102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.74 22.094-0.38672-0.75391c1.8594-0.94531 3.0156-2.832 3.0156-4.9141 0-1.9922-1.0781-3.8359-2.8203-4.8086l-0.19532-0.10547 0.39063-0.75 0.21875 0.11328c2.0078 1.125 3.2539 3.25 3.2539 5.5508 0 2.4062-1.332 4.5781-3.4766 5.668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.96 20.598c-1.6289-0.7461-2.6797-2.3828-2.6797-4.1719 0-1.707 0.9375-3.2617 2.4492-4.0586l0.23047-0.11719 0.35546 0.76953-0.1914 0.0977c-1.2305 0.64843-1.9961 1.9141-1.9961 3.3086 0 1.457 0.85547 2.793 2.1836 3.4023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.77 20.598-0.35547-0.76954c1.3281-0.60546 2.1875-1.9414 2.1875-3.4023 0-1.3945-0.76563-2.6602-1.9961-3.3125l-0.1875-0.0898 0.35157-0.77344 0.23046 0.11328c1.5117 0.80078 2.4492 2.3555 2.4492 4.0625 0 1.7891-1.0508 3.4297-2.6797 4.1719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.06 18.961c-1.1133-0.35157-1.8594-1.3711-1.8594-2.5352 0-1.0586 0.625-2.0156 1.5938-2.4375 0.0859-0.0391 0.17578-0.0742 0.26953-0.10156l0.25 0.80859-0.17969 0.0664c-0.66015 0.29297-1.0898 0.9414-1.0898 1.6641 0 0.79297 0.51172 1.4883 1.2695 1.7266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.66 18.965-0.25782-0.8125c0.76172-0.23828 1.2695-0.93359 1.2695-1.7266 0-0.72266-0.42579-1.375-1.0859-1.6641l-0.1836-0.0664 0.26172-0.80859 0.26563 0.10156c0.96484 0.42188 1.5859 1.3789 1.5859 2.4375 0 1.168-0.7461 2.1836-1.8555 2.5391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.51 16.426c0 0.35547-0.28907 0.64453-0.64453 0.64453-0.35547 0-0.64454-0.28906-0.64454-0.64453s0.28907-0.64453 0.64454-0.64453c0.35546 0 0.64453 0.28906 0.64453 0.64453"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-515.3 -397.75)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 589.125,
    y: 437.63199,
    xlinkHref: "#glyph-1-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 594.36523,
    y: 437.63199,
    xlinkHref: "#glyph-1-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 600.02936,
    y: 437.63199,
    xlinkHref: "#glyph-1-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 608.64648,
    y: 437.56754,
    xlinkHref: "#glyph-2-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 616.43048,
    y: 437.56754,
    xlinkHref: "#glyph-2-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 626.04303,
    y: 433.25427,
    xlinkHref: "#glyph-3-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 630.49103,
    y: 433.25427,
    xlinkHref: "#glyph-3-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 626.09698,
    y: 559.22998,
    xlinkHref: "#glyph-18-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 628.20184,
    y: 559.22998,
    xlinkHref: "#glyph-18-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 629.2392,
    y: 559.22998,
    xlinkHref: "#glyph-18-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 631.31421,
    y: 559.22998,
    xlinkHref: "#glyph-18-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 633.48724,
    y: 559.22998,
    xlinkHref: "#glyph-18-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 635.85522,
    y: 559.22998,
    xlinkHref: "#glyph-18-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 626.09698,
    y: 563.03003,
    xlinkHref: "#glyph-18-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 628.20184,
    y: 563.03003,
    xlinkHref: "#glyph-18-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 629.2392,
    y: 563.03003,
    xlinkHref: "#glyph-18-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 631.2439,
    y: 563.03003,
    xlinkHref: "#glyph-18-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 633.35138,
    y: 563.03003,
    xlinkHref: "#glyph-18-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 635.38654,
    y: 563.03003,
    xlinkHref: "#glyph-18-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 626.09698,
    y: 566.83002,
    xlinkHref: "#glyph-18-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 628.20184,
    y: 566.83002,
    xlinkHref: "#glyph-18-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 629.2392,
    y: 566.83002,
    xlinkHref: "#glyph-18-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 631.2439,
    y: 566.83002,
    xlinkHref: "#glyph-18-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 633.35138,
    y: 566.83002,
    xlinkHref: "#glyph-18-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 635.38654,
    y: 566.83002,
    xlinkHref: "#glyph-18-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 607.37323,
    y: 566.86047,
    xlinkHref: "#glyph-18-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 609.43964,
    y: 566.86047,
    xlinkHref: "#glyph-18-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 611.98572,
    y: 566.86047,
    xlinkHref: "#glyph-18-9"
  }), /*#__PURE__*/React.createElement("use", {
    x: 614.49469,
    y: 566.86047,
    xlinkHref: "#glyph-18-10"
  }), /*#__PURE__*/React.createElement("use", {
    x: 616.12238,
    y: 566.86047,
    xlinkHref: "#glyph-18-11"
  }), /*#__PURE__*/React.createElement("use", {
    x: 617.31299,
    y: 566.69501,
    xlinkHref: "#glyph-19-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 559.29602,
    y: 563.83801,
    xlinkHref: "#glyph-13-0"
  }), /*#__PURE__*/React.createElement("use", {
    x: 562.026,
    y: 563.83801,
    xlinkHref: "#glyph-13-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 565.04999,
    y: 563.83801,
    xlinkHref: "#glyph-13-2"
  }), /*#__PURE__*/React.createElement("use", {
    x: 567.13202,
    y: 563.83801,
    xlinkHref: "#glyph-13-1"
  }), /*#__PURE__*/React.createElement("use", {
    x: 570.15601,
    y: 563.83801,
    xlinkHref: "#glyph-13-3"
  }), /*#__PURE__*/React.createElement("use", {
    x: 573.57599,
    y: 563.83801,
    xlinkHref: "#glyph-13-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 576.89398,
    y: 563.83801,
    xlinkHref: "#glyph-13-5"
  }), /*#__PURE__*/React.createElement("use", {
    x: 582.12598,
    y: 563.83801,
    xlinkHref: "#glyph-13-6"
  }), /*#__PURE__*/React.createElement("use", {
    x: 585.06006,
    y: 563.83801,
    xlinkHref: "#glyph-13-7"
  }), /*#__PURE__*/React.createElement("use", {
    x: 586.37408,
    y: 563.83801,
    xlinkHref: "#glyph-13-8"
  }), /*#__PURE__*/React.createElement("use", {
    x: 589.01398,
    y: 563.83801,
    xlinkHref: "#glyph-13-4"
  }), /*#__PURE__*/React.createElement("use", {
    x: 592.33197,
    y: 563.83801,
    xlinkHref: "#glyph-13-5"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.062 154.44h-1.5391v4.6875h1.5391zm1.5938-1.5977v14.148h-1.5547v-6.2539h-1.5938v6.2578h-1.5742v-14.152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.359 152.84v1.5625h-1.5547v4.7227h1.5313v1.5781h-1.5352v4.7305h1.5391v1.5781h-3.1289v-14.172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.383 167.02h-3.1524v-14.172h3.1524v1.5742h-1.5586v11.023h1.5586"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m51.18 8.4922c-2.5117 0-3.3984 3.9766-4.2226 7.168-0.30079-0.30469-1.2188-1.2383-1.2188-1.2344-0.1836-0.1875-0.39844-0.12891-0.52735 4e-3 -0.1289 0.1289-0.14844 0.3789 0 0.52734 8e-3 8e-3 1.2461 1.2617 1.6719 1.6953 0.12109 0.11719 0.28906 0.1875 0.46093 0.0859 0.17579-0.10547 0.20313-0.30469 0.20704-0.30469 1.4648-6.6914 2.7734-7.1875 3.625-7.1875 0.71875 0 1.543 0.53907 1.543 1.6133 1.0703 0 1.7383 1.4258 0.87891 2.3086 0.71094 0.34765 1.0273 0.77734 1.0273 1.3242 0 0.54687-0.44921 1.1055-1.1055 1.1055-0.65235 0-0.98047-0.42579-1.4883-0.42579-0.22656 0-0.36718 0.1836-0.36718 0.375v1.3477h-0.95703v-1.3438c0-0.21094-0.15625-0.37891-0.34375-0.37891l-0.082 8e-3 -1.2812 0.16015c-0.15625 0.0195-0.29687 0.19141-0.29687 0.3711 0 0.20312 0.16406 0.3789 0.39453 0.375l0.0586-8e-3 0.81641-0.10546v1.3359c0 0.16797 0.18359 0.33203 0.35156 0.33203h1.707c0.19922 0 0.3711-0.17187 0.3711-0.3789v-1.2148c0.35547 0.21875 0.85156 0.3086 1.1055 0.3086 0.95312 0 1.8672-0.76563 1.8594-1.8828 0-1.0195-0.76562-1.5274-0.76562-1.5274 0.44922-1.2148-0.27735-2.3867-1.2148-2.7148-0.33984-1.25-1.3945-1.7383-2.207-1.7383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.18 8.4922c-2.5117 0-3.3984 3.9766-4.2226 7.168-0.30079-0.30469-1.2188-1.2383-1.2188-1.2344-0.1836-0.1875-0.39844-0.12891-0.52735 4e-3 -0.1289 0.1289-0.14844 0.3789 0 0.52734 8e-3 8e-3 1.2461 1.2617 1.6719 1.6953 0.12109 0.11719 0.28906 0.1875 0.46093 0.0859 0.17579-0.10547 0.20313-0.30469 0.20704-0.30469 1.4648-6.6914 2.7734-7.1875 3.625-7.1875 0.71875 0 1.543 0.53907 1.543 1.6133 1.0703 0 1.7383 1.4258 0.87891 2.3086 0.71094 0.34765 1.0273 0.77734 1.0273 1.3242 0 0.54687-0.44921 1.1055-1.1055 1.1055-0.65235 0-0.98047-0.42579-1.4883-0.42579-0.22656 0-0.36718 0.1836-0.36718 0.375v1.3477h-0.95703v-1.3438c0-0.21094-0.15625-0.37891-0.34375-0.37891l-0.082 8e-3 -1.2812 0.16015c-0.15625 0.0195-0.29687 0.19141-0.29687 0.3711 0 0.20312 0.16406 0.3789 0.39453 0.375l0.0586-8e-3 0.81641-0.10546v1.3359c0 0.16797 0.18359 0.33203 0.35156 0.33203h1.707c0.19922 0 0.3711-0.17187 0.3711-0.3789v-1.2148c0.35547 0.21875 0.85156 0.3086 1.1055 0.3086 0.95312 0 1.8672-0.76563 1.8594-1.8828 0-1.0195-0.76562-1.5274-0.76562-1.5274 0.44922-1.2148-0.27735-2.3867-1.2148-2.7148-0.33984-1.25-1.3945-1.7383-2.207-1.7383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.109 19.133c0 0.3125 0.34375 0.50391 0.91016 0.77344 0.44921 0.21484 0.70703 0.44531 0.70703 0.625 0 0.29687-0.3086 0.40234-0.60157 0.40234-0.45312 0-0.71875-0.1875-0.86718-0.59375l-0.0117-0.0351h-0.0352l-0.17969 0.0469-0.0117 0.14844 0.10156 0.42187c0.0234 0.10547 0.0625 0.1211 0.22265 0.15235 0.0742 0.0156 0.4375 0.0781 0.7461 0.0781 0.86328 0 1.25-0.35547 1.25-0.71093 0-0.25782-0.25-0.50391-0.79297-0.78125l-0.24609-0.1211c-0.3711-0.17969-0.58985-0.28515-0.58985-0.47265 0-0.1836 0.22656-0.3125 0.5586-0.3125 0.43359 0 0.54687 0.24609 0.60546 0.46093l4e-3 0.0391h0.043c0.0977 0 0.16016-8e-3 0.19141-0.0508l0.0234-0.0859-0.0312-0.36719c-0.0117-0.11328-0.0976-0.13281-0.21875-0.15625-0.14453-0.0273-0.32031-0.0586-0.58203-0.0586-0.75 0-1.1953 0.22265-1.1953 0.59765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.594 19.871c0 0.63672 0.54297 1.2812 1.582 1.2812 0.52343 0 0.8164-0.125 1.0352-0.24218l0.0625-0.0312-0.0976-0.10938 8e-3 4e-3 -0.0781-0.0391-0.0508 0.0195c-0.0781 0.0351-0.32031 0.14843-0.7539 0.14843-0.53516 0-1.1133-0.35156-1.1133-1.1367 0-0.75 0.625-1.0117 1.1602-1.0117 0.38281 0 0.58984 0.14062 0.625 0.42968l8e-3 0.0469h0.0469c0.0469 0 0.16797 0 0.16797-0.0899v-0.4414c0-0.10156-0.1211-0.1211-0.17188-0.12891l-0.0508-4e-3c-0.12109-0.0156-0.24219-0.0312-0.55469-0.0312-1.0547 0-1.8242 0.5625-1.8242 1.3359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.684 18.566-0.9336 4e-3 -0.625-8e-3 -0.0937-4e-3 -0.0937 0.10157c0 0.0273 0 0.11328 0.10157 0.11328 0.3789 0 0.39062 0.0273 0.39453 0.17578l4e-3 0.0937 4e-3 0.39062v0.84375c0 0.14063-4e-3 0.35938-0.0117 0.54297-4e-3 0.0508-4e-3 0.10156-0.33984 0.10156-0.0898 0-0.14844 0.0156-0.14844 0.10938l0.0898 0.10156h0.0234c0.0391-4e-3 0.14453-8e-3 0.66406-8e-3 0.55469 0 0.66407 4e-3 0.70313 8e-3h0.0195c0.0703 0 0.13281-8e-3 0.13281-0.10156 0-0.10547-0.082-0.10938-0.22265-0.10938-0.33594 0-0.33594-0.0508-0.33985-0.10156-8e-3 -0.16797-0.0117-0.38672-0.0117-0.54297v-0.30078h0.27735c0.42969 0 0.47656 8e-3 0.53906 0.34375l0.12109 0.082c0.10157 0 0.11329-0.0547 0.11329-0.0781l-8e-3 -0.12891c-4e-3 -0.0664-0.0156-0.16015-0.0156-0.28125v-0.51562l-0.14063-0.0781c-0.0781 0-0.0976 0.0508-0.14843 0.29297-0.0234 0.0977-0.19922 0.14844-0.48438 0.14844h-0.25391v-0.75781c0-0.20704 0.0391-0.20704 0.082-0.21094 0.16015-8e-3 0.55859-0.0195 0.67968-0.0195 0.11328 0 0.21875 0.0234 0.28516 0.0703 0.21094 0.13281 0.32031 0.22656 0.38672 0.28125l0.15234 0.082 0.1211-0.0781-0.0391-0.10157c-0.0312-0.082-0.0898-0.20703-0.16406-0.40234-0.0234-0.0625-0.0898-0.0625-0.22266-0.0625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.738 25.719h-0.20313v-1.3594h-8e-3l-0.46875 1.3594h-0.19531l-0.46875-1.3828h-8e-3v1.3828h-0.20312v-1.625h0.32422l0.38672 1.1523c0.043 0.125 0.0703 0.20703 0.0742 0.23828h4e-3c0.0234-0.0625 0.0508-0.14843 0.0859-0.26171l0.39453-1.1289h0.28516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.215 25.719h0.21484v-1.625h-0.21484z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.238 25.719h-0.26954l-0.32812-0.46094c-0.082-0.11328-0.12891-0.1875-0.15234-0.22656h-4e-3c0 0.0117-0.16406 0.24219-0.48438 0.6875h-0.26171l0.63281-0.84766-0.5586-0.77734h0.25391l0.34766 0.48437 0.082 0.13282c0.0273-0.0508 0.18359-0.25391 0.46094-0.61719h0.23437l-0.57031 0.76562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.977 28.008h-0.88672v0.50391h0.76953v0.1914h-0.76953v0.73829h-0.21485v-1.625h1.1016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.324 28.293c-8e-3 -0.10547-0.0469-0.1836-0.10937-0.23438-0.0703-0.0508-0.16406-0.0781-0.28906-0.0781-0.10938 0-0.20313 0.0195-0.27344 0.0625l-0.10156 0.17969 0.082 0.15625c0.0508 0.0351 0.15625 0.0703 0.30859 0.10546 0.13281 0.0274 0.24609 0.0586 0.33203 0.0899l0.21875 0.14453c0.0586 0.0625 0.0937 0.15234 0.0937 0.26172 0 0.14062-0.0586 0.25781-0.16797 0.34765-0.11328 0.0937-0.26172 0.14063-0.4414 0.14063-0.22657 0-0.40235-0.0508-0.51172-0.15234-0.11719-0.10157-0.17578-0.23438-0.1875-0.39844l0.20703-0.0195c0.0117 0.13281 0.0625 0.22656 0.15234 0.28515 0.0899 0.0586 0.20313 0.0899 0.33203 0.0899 0.1211 0 0.21875-0.0234 0.29297-0.0742l0.11328-0.19922-0.11718-0.19531c-0.0781-0.043-0.20703-0.082-0.39453-0.1211-0.1836-0.0391-0.3125-0.0937-0.39454-0.16797-0.082-0.0703-0.125-0.16406-0.125-0.27734 0-0.13281 0.0508-0.23828 0.15625-0.32422 0.10157-0.0859 0.24219-0.125 0.41797-0.125 0.17969 0 0.32813 0.0391 0.4375 0.125 0.11328 0.082 0.16797 0.20313 0.17578 0.35938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.352 28.926c-0.0469 0.18359-0.12891 0.31641-0.25 0.40625-0.11719 0.0898-0.25782 0.13672-0.42578 0.13672-0.26954 0-0.46485-0.082-0.58594-0.25-0.1211-0.16797-0.1836-0.36719-0.1836-0.60156 0-0.26172 0.0703-0.46094 0.21485-0.60938 0.14453-0.14453 0.32812-0.21875 0.55859-0.21875 0.15625 0 0.29297 0.0391 0.40625 0.1211 0.11328 0.0781 0.19141 0.19531 0.23828 0.35156l-0.21093 0.0508c-0.0391-0.11328-0.0899-0.19922-0.16407-0.25781-0.0742-0.0547-0.16406-0.082-0.27343-0.082-0.17969 0-0.3125 0.0547-0.40625 0.17187-0.0937 0.11719-0.14063 0.27344-0.14063 0.46875 0 0.22656 0.0508 0.39453 0.14844 0.50391 0.0937 0.11328 0.22265 0.16797 0.3789 0.16797 0.12891 0 0.23047-0.0352 0.3125-0.10547 0.0781-0.0664 0.13282-0.17188 0.16797-0.3086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.164 27.867h-0.17969v0.46093h-0.0898v-0.46093h-0.17579v-0.0781h0.44532zm0.59765 0.46093h-0.082v-0.45312h-4e-3l-0.13672 0.45312h-0.082l-0.14454-0.46093h-4e-3v0.46093h-0.082v-0.53906h0.13281l0.13672 0.4336h4e-3l0.12891-0.4336h0.13281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.324 28.625c0 0.26953 0.0352 0.45312 0.0977 0.54297 0.0625 0.0898 0.14062 0.13281 0.23437 0.13281 0.0977 0 0.17579-0.043 0.23829-0.13672 0.0625-0.0898 0.0937-0.26953 0.0937-0.53906 0-0.27344-0.0312-0.45313-0.0937-0.54297-0.0625-0.0898-0.14454-0.13672-0.23829-0.13672-0.0937 0-0.16796 0.0391-0.22656 0.11719-0.0703 0.10156-0.10547 0.28906-0.10547 0.5625m-0.20703 0c0-0.19922 0.0195-0.35547 0.0625-0.47266 0.0391-0.12109 0.0977-0.21484 0.17578-0.27734 0.082-0.0664 0.17969-0.0977 0.30078-0.0977l0.23438 0.0547 0.16797 0.15234c0.043 0.0703 0.0781 0.15235 0.10156 0.2461 0.0234 0.0976 0.0391 0.23047 0.0391 0.39453 0 0.19141-0.0195 0.35156-0.0625 0.46875-0.0391 0.12109-0.0976 0.21484-0.17578 0.27734-0.082 0.0664-0.18359 0.0977-0.30469 0.0977-0.15625 0-0.28125-0.0547-0.375-0.17188-0.10937-0.13671-0.16406-0.35937-0.16406-0.67187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.613 28.625c0 0.26953 0.0312 0.45312 0.0976 0.54297 0.0625 0.0898 0.14063 0.13281 0.23438 0.13281 0.0937 0 0.17187-0.043 0.23437-0.13672 0.0625-0.0898 0.0977-0.26953 0.0977-0.53906 0-0.27344-0.0352-0.45313-0.0977-0.54297-0.0625-0.0898-0.14062-0.13672-0.23828-0.13672-0.0937 0-0.16797 0.0391-0.22266 0.11719-0.0703 0.10156-0.10546 0.28906-0.10546 0.5625m-0.20704 0c0-0.19922 0.0195-0.35547 0.0586-0.47266 0.043-0.12109 0.10156-0.21484 0.17969-0.27734 0.0781-0.0664 0.17968-0.0977 0.30078-0.0977l0.23437 0.0547 0.16406 0.15234c0.0469 0.0703 0.0781 0.15235 0.10547 0.2461 0.0234 0.0976 0.0352 0.23047 0.0352 0.39453 0 0.19141-0.0195 0.35156-0.0586 0.46875-0.0391 0.12109-0.10157 0.21484-0.17969 0.27734-0.0781 0.0664-0.17969 0.0977-0.30078 0.0977-0.16016 0-0.28516-0.0547-0.375-0.17188-0.10938-0.13671-0.16407-0.35937-0.16407-0.67187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.902 28.625c0 0.26953 0.0312 0.45312 0.0937 0.54297 0.0625 0.0898 0.14453 0.13281 0.23437 0.13281 0.0937 0 0.17188-0.043 0.23828-0.13672 0.0625-0.0898 0.0937-0.26953 0.0937-0.53906 0-0.27344-0.0312-0.45313-0.0937-0.54297-0.0664-0.0898-0.14453-0.13672-0.23828-0.13672-0.0937 0-0.16797 0.0391-0.22656 0.11719-0.0664 0.10156-0.10156 0.28906-0.10156 0.5625m-0.21094 0c0-0.19922 0.0195-0.35547 0.0625-0.47266 0.0391-0.12109 0.0977-0.21484 0.17969-0.27734 0.0781-0.0664 0.17578-0.0977 0.29687-0.0977l0.23438 0.0547 0.16797 0.15234c0.043 0.0703 0.0781 0.15235 0.10156 0.2461 0.0273 0.0976 0.0391 0.23047 0.0391 0.39453 0 0.19141-0.0195 0.35156-0.0586 0.46875-0.043 0.12109-0.10156 0.21484-0.1836 0.27734-0.0781 0.0664-0.17578 0.0977-0.30078 0.0977-0.16015 0-0.28515-0.0547-0.375-0.17188-0.10937-0.13671-0.16406-0.35937-0.16406-0.67187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.187 28.625c0 0.26953 0.0312 0.45312 0.0977 0.54297 0.0625 0.0898 0.14063 0.13281 0.23438 0.13281 0.0937 0 0.17187-0.043 0.23437-0.13672 0.0664-0.0898 0.0977-0.26953 0.0977-0.53906 0-0.27344-0.0312-0.45313-0.0977-0.54297-0.0625-0.0898-0.14062-0.13672-0.23828-0.13672-0.0937 0-0.16797 0.0391-0.22266 0.11719-0.0703 0.10156-0.10547 0.28906-0.10547 0.5625m-0.20703 0c0-0.19922 0.0195-0.35547 0.0625-0.47266 0.0391-0.12109 0.0977-0.21484 0.17578-0.27734 0.0781-0.0664 0.17969-0.0977 0.30079-0.0977l0.23437 0.0547 0.16406 0.15234c0.0469 0.0703 0.082 0.15235 0.10547 0.2461 0.0234 0.0976 0.0352 0.23047 0.0352 0.39453 0 0.19141-0.0156 0.35156-0.0586 0.46875-0.0391 0.12109-0.0977 0.21484-0.17968 0.27734-0.0781 0.0664-0.17969 0.0977-0.30078 0.0977-0.16016 0-0.28516-0.0547-0.375-0.17188-0.10938-0.13671-0.16407-0.35937-0.16407-0.67187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.477 28.625c0 0.26953 0.0312 0.45312 0.0937 0.54297 0.0664 0.0898 0.14453 0.13281 0.23828 0.13281 0.0937 0 0.17187-0.043 0.23437-0.13672 0.0625-0.0898 0.0977-0.26953 0.0977-0.53906 0-0.27344-0.0352-0.45313-0.0977-0.54297-0.0625-0.0898-0.14453-0.13672-0.23828-0.13672-0.0937 0-0.16797 0.0391-0.22265 0.11719-0.0703 0.10156-0.10547 0.28906-0.10547 0.5625m-0.21094 0c0-0.19922 0.0234-0.35547 0.0625-0.47266 0.0391-0.12109 0.10156-0.21484 0.17969-0.27734 0.0781-0.0664 0.17968-0.0977 0.30078-0.0977l0.23047 0.0547 0.16797 0.15234c0.043 0.0703 0.0781 0.15235 0.10156 0.2461 0.0273 0.0976 0.0391 0.23047 0.0391 0.39453 0 0.19141-0.0195 0.35156-0.0586 0.46875-0.043 0.12109-0.10157 0.21484-0.17969 0.27734-0.082 0.0664-0.17969 0.0977-0.30078 0.0977-0.16016 0-0.28516-0.0547-0.37891-0.17188-0.10937-0.13671-0.16406-0.35937-0.16406-0.67187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.762 28.625c0 0.26953 0.0352 0.45312 0.0977 0.54297 0.0625 0.0898 0.14062 0.13281 0.23437 0.13281 0.0937 0 0.17188-0.043 0.23829-0.13672 0.0625-0.0898 0.0937-0.26953 0.0937-0.53906 0-0.27344-0.0312-0.45313-0.0937-0.54297-0.0664-0.0898-0.14454-0.13672-0.23829-0.13672-0.0937 0-0.16796 0.0391-0.22656 0.11719-0.0703 0.10156-0.10547 0.28906-0.10547 0.5625m-0.20703 0c0-0.19922 0.0195-0.35547 0.0586-0.47266 0.043-0.12109 0.10156-0.21484 0.17968-0.27734 0.082-0.0664 0.17969-0.0977 0.30078-0.0977l0.23438 0.0547 0.16406 0.15234c0.0469 0.0703 0.0781 0.15235 0.10547 0.2461 0.0234 0.0976 0.0391 0.23047 0.0391 0.39453 0 0.19141-0.0234 0.35156-0.0625 0.46875-0.0391 0.12109-0.0976 0.21484-0.17968 0.27734-0.0781 0.0664-0.17969 0.0977-0.30079 0.0977-0.16015 0-0.28515-0.0547-0.375-0.17188-0.10937-0.13671-0.16406-0.35937-0.16406-0.67187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.051 28.625c0 0.26953 0.0312 0.45312 0.0976 0.54297 0.0625 0.0898 0.14063 0.13281 0.23438 0.13281 0.0937 0 0.17187-0.043 0.23437-0.13672 0.0625-0.0898 0.0977-0.26953 0.0977-0.53906 0-0.27344-0.0352-0.45313-0.0977-0.54297-0.0625-0.0898-0.14062-0.13672-0.23828-0.13672-0.0937 0-0.16797 0.0391-0.22266 0.11719-0.0703 0.10156-0.10546 0.28906-0.10546 0.5625m-0.21094 0c0-0.19922 0.0234-0.35547 0.0625-0.47266 0.0391-0.12109 0.10156-0.21484 0.17969-0.27734 0.0781-0.0664 0.17968-0.0977 0.30078-0.0977l0.23047 0.0547 0.16796 0.15234c0.043 0.0703 0.0781 0.15235 0.10157 0.2461 0.0273 0.0976 0.0391 0.23047 0.0391 0.39453 0 0.19141-0.0195 0.35156-0.0586 0.46875-0.043 0.12109-0.10157 0.21484-0.17969 0.27734-0.0781 0.0664-0.17969 0.0977-0.30078 0.0977-0.16016 0-0.28516-0.0547-0.37891-0.17188-0.10547-0.13671-0.16406-0.35937-0.16406-0.67187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.984 8.6016h-0.17969v0.46485h-0.0937v-0.46485h-0.17187v-0.0742h0.44531zm0.59766 0.46485h-0.082v-0.45704h-4e-3l-0.13672 0.45704h-0.082l-0.14844-0.46485v0.46485h-0.0859v-0.53907h0.13672l0.13281 0.42969h4e-3l0.13281-0.42969h0.13282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.227 18.727 1.2226-1.1758 0.0195 0.59375 1.0508-4e-3 1.0547-8e-3 0.1836-0.0664c0.10156-0.0352 0.23437-0.0977 0.29687-0.14063 0.38281-0.26562 0.47266-0.75391 0.23828-1.2695-0.0351-0.0703-0.38672-0.69141-0.78125-1.375s-0.71093-1.25-0.70312-1.2578l0.9375-0.53125c8e-3 0.0117 0.32812 0.5664 0.71875 1.2383 0.79297 1.3711 0.85937 1.5 0.96484 1.8164 0.41016 1.2148-0.082 2.2148-1.2578 2.5547-0.35938 0.10156-0.39453 0.10547-1.5664 0.1211l-1.1289 0.0117-0.0195 0.67969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.156 19.18c-0.76953-0.13672-1.3242-0.50391-1.5859-1.043-0.11328-0.23438-0.14453-0.39063-0.16016-0.69922-0.0156-0.32031 0.0195-0.54297 0.13672-0.89063 0.0977-0.29687 0.21875-0.52734 0.68359-1.3281 0.21094-0.36719 0.38282-0.67188 0.37891-0.67578l-0.50781-0.3125 1.6328-0.46094 0.39844 1.6367-0.58203-0.26563c-0.0664 0.0937-0.82813 1.4258-0.87891 1.543-0.0898 0.19141-0.125 0.39063-0.11328 0.57813 0.0234 0.40234 0.24219 0.66797 0.67187 0.8125l0.17188 0.0586 1.5586 8e-3 1.5625 4e-3v1.0781l-1.5703-4e-3c-1.4062 0-1.5977-4e-3 -1.7969-0.0391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.715 12.703c-0.0195-0.0195 1.3281-2.3672 1.5078-2.6289 0.19922-0.28906 0.5-0.59375 0.74609-0.76172 0.14844-0.10547 0.44532-0.23828 0.62891-0.28516 0.47656-0.12109 1.0312 4e-3 1.4727 0.33203 0.21875 0.16016 0.54297 0.50782 0.70703 0.75782 0.082 0.12109 0.32812 0.53906 0.55078 0.92578s0.41016 0.70703 0.41016 0.71094l0.52734-0.27735-0.41406 1.6367-1.6211-0.46094 0.54688-0.35156c0-0.0312-0.83985-1.4688-0.94141-1.6133-0.26172-0.36719-0.64453-0.55859-0.98437-0.49219-0.26953 0.0508-0.53516 0.23438-0.71485 0.4961-0.0508 0.0703-0.39843 0.66406-0.78515 1.3242-0.37891 0.66407-0.70313 1.207-0.71485 1.2109-0.3125-0.16015-0.6289-0.33203-0.92187-0.52344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.711 16.094v0.50781h-1.9648v-0.38281l0.69531-0.75c0.48047-0.52344 0.5625-0.66016 0.5625-0.90625 0-0.25-0.17187-0.40625-0.49219-0.40625-0.33984 0-0.57812 0.13281-0.69922 0.24609h-8e-3v-0.61328c0.13672-0.0859 0.41406-0.1914 0.78906-0.1914 0.65625 0 1.0586 0.3789 1.0586 0.91406 0 0.42187-0.17578 0.70703-0.69531 1.2305l-0.35547 0.35156h1.0859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.012 16.094v0.50781h-1.9688v-0.38281l0.69922-0.75c0.48047-0.52344 0.5586-0.66016 0.5586-0.90625 0-0.25-0.16797-0.40625-0.49219-0.40625-0.33985 0-0.57813 0.13281-0.69531 0.24609h-8e-3v-0.61328c0.13672-0.0859 0.41016-0.1914 0.78907-0.1914 0.65234 0 1.0547 0.3789 1.0547 0.91406 0 0.42187-0.17187 0.70703-0.69531 1.2305l-0.35156 0.35156h1.082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.535 22.238 0.20703 0.0156c0.3125 0 0.50391-0.15235 0.50391-0.42188 0-0.25391-0.17969-0.39062-0.46875-0.39062-0.11328 0-0.19531 0.0117-0.24219 0.0195zm-0.41797-1.0664c0.15235-0.0273 0.35938-0.0508 0.64453-0.0508 0.30469 0 0.53125 0.0664 0.67969 0.1875 0.13281 0.11328 0.22266 0.29297 0.22266 0.50782 0 0.21875-0.0664 0.39843-0.19532 0.51953-0.16796 0.16797-0.42968 0.24609-0.72656 0.24609l-0.20703-0.0156v0.86718h-0.41797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.062 22.465-0.17968-0.5625c-0.043-0.14062-0.082-0.29687-0.11719-0.42968h-4e-3c-0.0351 0.13281-0.0703 0.29296-0.10937 0.42968l-0.17969 0.5625zm-0.65625 0.31641-0.19921 0.65234h-0.4336l0.73828-2.293h0.53516l0.74609 2.293h-0.44922l-0.20703-0.65234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.691 22.238 0.20703 0.0156c0.3125 0 0.50391-0.15235 0.50391-0.42188 0-0.25391-0.17969-0.39062-0.46875-0.39062-0.11719 0-0.19922 0.0117-0.24219 0.0195zm-0.41406-1.0664c0.14844-0.0273 0.35547-0.0508 0.64062-0.0508 0.30469 0 0.53125 0.0664 0.67969 0.1875 0.13672 0.11328 0.22266 0.29297 0.22266 0.50782 0 0.21875-0.0664 0.39843-0.19532 0.51953-0.16796 0.16797-0.43359 0.24609-0.72656 0.24609l-0.20703-0.0156v0.86718h-0.41406"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1.1367 5.0196h17.621c5.0469 0 9.1523 4.1562 9.1523 9.2617v53.102h-17.621c-5.0469 0-9.1524-4.1523-9.1524-9.2578",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.387 65.258h11.398v-31.844c0-3.9336-3.1523-7.1328-7.0273-7.1328h-11.398v31.844c0 3.9336 3.1523 7.1328 7.0273 7.1328",
    fill: "#171817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.387 64.551c-3.4844 0-6.3203-2.8828-6.3203-6.4258v-31.137h10.691c3.4844 0 6.3164 2.8828 6.3164 6.4258v31.137",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.3593 58.125c0 3.9336 3.1523 7.1328 7.0273 7.1328h11.395v-22.676l-9.2109 4.5391-9.2109-4.543",
    fill: "#171817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.387 64.551c-3.4844 0-6.3203-2.8828-6.3203-6.4258v-14.406l8.5039 4.1914 8.5039-4.1875v20.828",
    fill: "#171817"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.652 60.211h-0.45313l-0.10547 0.0117c0.21094-2.3477 0.53907-5.9688 0.69532-7.6094 0.0156-0.16797-0.10547-0.31641-0.27344-0.33203-0.17188-0.0195-0.31641 0.10547-0.33203 0.27344-0.24219 2.5195-0.88281 9.7109-0.88672 9.7852-0.0156 0.1211-0.13281 0.21875-0.26953 0.21875h-4.9102c-0.14062 0-0.25781-0.0976-0.26953-0.21875-8e-3 -0.0742-0.64844-7.2656-0.88672-9.7852-0.0195-0.16797-0.16406-0.29297-0.33203-0.27344-0.16797 0.0156-0.29297 0.16406-0.27734 0.33203 0.16015 1.6406 0.48437 5.2578 0.69531 7.6094l-0.10547-0.0117h-0.45312c-0.28907 0-0.52735 0.23437-0.52735 0.52734v1.9023c0 0.29297 0.23828 0.52735 0.52735 0.52735h0.45312c0.21875 0 0.40625-0.13281 0.48438-0.32422 0.16406 0.19922 0.41015 0.32422 0.6914 0.32422h4.9102c0.27734 0 0.52734-0.125 0.6875-0.32422 0.0781 0.19141 0.26562 0.32812 0.48437 0.32812h0.45313c0.28906 0 0.52734-0.23828 0.52734-0.53125v-1.9023c0-0.28906-0.23828-0.52734-0.52734-0.52734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.961 49.832h-0.52734l-0.71485-0.625c-0.15234-0.13281-0.3789-0.21094-0.62109-0.21094h-5.0508c-0.24219 0-0.47266 0.0781-0.625 0.21094l-0.71094 0.625h-0.52734c-0.33203 0-0.60156 0.28125-0.60156 0.63281v0.80078c0 0.11329 0.0273 0.22266 0.082 0.32032l0.0937 0.10156c0.0976 0.0664 0.21093 0.10156 0.32422 0.10156h8.9766c0.11719 0 0.23047-0.0351 0.32812-0.10156l0.0937-0.10156c0.0547-0.0977 0.082-0.20703 0.082-0.32032v-0.80078c0-0.35156-0.26953-0.63281-0.60156-0.63281m8e-3 1.3633h-8.793v-0.73047l8e-3 -0.0391h0.63672l0.19531-0.0742 0.79687-0.69922c0.0352-0.0312 0.125-0.0625 0.23438-0.0625h5.0508c0.10938 0 0.19531 0.0312 0.23047 0.0625l0.80078 0.69922 0.19531 0.0742h0.63672l8e-3 0.0391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.094 49.867h-5.0469c-0.13672 0-0.25 0.11328-0.25 0.25 0 0.14062 0.11328 0.2539 0.25 0.2539h5.0469c0.14063 0 0.25391-0.11328 0.25391-0.2539 0-0.13672-0.11328-0.25-0.25391-0.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.043 55.637c-0.0625-0.15625-0.23828-0.22656-0.39062-0.16406-0.15235 0.0625-0.22656 0.23828-0.16406 0.39062 0.10546 0.25391 0.16015 0.52344 0.16015 0.79688 0 1.1445-0.93359 2.0742-2.0781 2.0742s-2.0742-0.92968-2.0742-2.0742c0-1.1445 0.92969-2.0781 2.0742-2.0781l0.0234 4e-3 -0.42578 0.42578c-0.11718 0.11719-0.11718 0.30859 0 0.42578l0.21094 0.0859 0.21094-0.0859 0.9414-0.94141c0.11719-0.11718 0.11719-0.30859 0-0.42578l-0.9414-0.9414c-0.11719-0.11719-0.30469-0.11719-0.42188 0-0.11718 0.11718-0.11718 0.30859 0 0.42578l0.42969 0.42968h-0.0273c-1.4766 0-2.6758 1.1992-2.6758 2.6758 0 1.4766 1.1992 2.6758 2.6758 2.6758 1.4766 0 2.6758-1.1992 2.6758-2.6758 0-0.35547-0.0664-0.69922-0.20313-1.0234"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#040606"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.586 16.184c-0.76172 1.1172-0.11719 2.5938 0.67188 3.3398 0.71484 0.67968 1.2891 0.83984 1.3633 0.85937l0.36719-0.69922 1.0547 2.8828-2.9844 0.60546 0.39844-0.73437-0.40235-0.22656c-1.2578-0.81641-1.5234-1.9297-1.6094-2.2734-0.14844-0.59766-0.3711-2.3867 1.1406-3.7539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.57 16.231c0.54297 1.2422 2.1328 1.4805 3.1836 1.2148 0.93359-0.23828 1.375-0.62109 1.4531-0.6914l-8e-3 -8e-3 -0.39843-0.6914 3 0.65625-1.0859 2.8438-0.40235-0.71485-0.39062 0.21094c-1.3633 0.625-2.4453 0.25781-2.7812 0.14453-0.58594-0.1914-2.2188-0.95703-2.5703-2.9648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.875 13.234c-0.20703 1.4844-1.1016 2.1953-1.3789 2.418-0.48047 0.39063-2.0039 1.3516-3.8828 0.5625 1.3359 0.21485 2.3984-0.99609 2.7422-2.0234 0.3086-0.92579 0.21485-1.5078 0.19922-1.5977h-0.0117l-0.79687-0.0352 2.168-2.1758 1.8125 2.4414-0.82032-0.0469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.773 11.981c-0.68359 0-1.2383-0.55469-1.2383-1.2383 0-0.6836 0.55469-1.2383 1.2383-1.2383 0.6875 0 1.2422 0.55468 1.2422 1.2383 0 0.68359-0.55469 1.2383-1.2422 1.2383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.469 7.1485c-4.4726 0-8.1133 3.6367-8.1133 8.1133 0 4.4726 3.6406 8.1133 8.1133 8.1133 0.23829 0 0.47657-0.0156 0.71094-0.0352l0.0508 0.8125 1.4844-1.4336-1.6602-1.2656 0.0625 0.85547c-0.21484 0.0195-0.42969 0.0352-0.64844 0.0352-0.34375 0-0.67968-0.0273-1.0117-0.0742l-0.0352-0.21875-0.76953-6.5703c-0.10547-1.2383 0.60156-1.4336 1.0391-1.25l2.4609 0.98828c0.28515 0.12109 0.41797-0.11328 0.41797-0.11328s0.16015-0.25-0.125-0.42969c0 0-3.3555-2.2227-4.0703-2.3555-0.97265-0.18359-1.9375 0.60547-2.1523 1.6367l-1.1914 5.832c-1.0234-1.2266-1.6406-2.8086-1.6406-4.5273 0-3.9024 3.1758-7.082 7.0781-7.082 2.0859 0 3.9609 0.91015 5.2578 2.3477l0.73047-0.73828c-1.4844-1.6211-3.6211-2.6406-5.9883-2.6406m-3.6133 10.855c0.10547-0.28907 0.26563-0.26954 0.26563-0.26954s0.14062-0.0312 0.22265 0.26172l1.1562 4.0664c-0.96484-0.28516-1.8476-0.76172-2.5976-1.3945"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m4.1836 39.746v-1.4453h0.5v0.85547h0.70703v-0.67969h0.50781v0.67969h0.77735v-0.85938h0.51171v1.4492",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m6.3672 38.113-0.0195-0.55859c0.1875-0.0156 0.40234-0.0586 0.40234-0.26953 0-0.16797-0.14453-0.21875-0.27734-0.21875-0.16406 0-0.28906 0.10546-0.45312 0.27734l-0.28125 0.28906c-0.25391 0.26953-0.50391 0.4336-0.83204 0.4336-0.41406 0-0.77343-0.26172-0.77343-0.79688 0-0.375 0.1914-0.72656 0.84765-0.75l0.0195 0.51953c-0.21875 0.0234-0.39062 0.0742-0.39062 0.25781 0 0.14844 0.11328 0.21485 0.25 0.21485 0.16016 0 0.3125-0.16406 0.44922-0.30469l0.26172-0.26562c0.27734-0.29297 0.53515-0.45704 0.87109-0.45704 0.44141 0 0.79297 0.30469 0.79297 0.80469s-0.33203 0.79297-0.86719 0.82422",
    fill: "#fff"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#050606"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.5234 36.734v0.24219h0.97656v-0.25c0-0.1875-0.13281-0.29687-0.5-0.29687-0.3164 0-0.48437 0.0976-0.48437 0.30468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.3281 36.418-1.332 0.34765v0.21875h1.332v0.66797h-3.3594v-0.96484c0-0.56641 0.30469-0.90625 0.99219-0.90625 0.48828 0 0.75781 0.16016 0.88672 0.38672l1.4805-0.4336zm-2.8047 1.5508v0.95703h0.8086v-0.75781h0.5664v0.75781h1.4219v0.65625h-3.3633v-1.6133zm-1.2617-2.3867v4.2188c0 0.77344 0.63672 1.4023 1.4024 1.4023h3.3594v-7.0312h-3.3594c-0.77735 0-1.4024 0.63672-1.4024 1.4102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.3828 28.781c0 0.35156-0.082 0.62109-0.23047 0.80078-0.15235 0.17969-0.41016 0.26953-0.78125 0.26953h-0.10156v-0.67969h0.0898c0.18359 0 0.3125-0.0312 0.40234-0.10156 0.0781-0.0703 0.12891-0.17969 0.12891-0.35156 0-0.11719-0.0391-0.21875-0.10938-0.28906-0.0703-0.0781-0.17187-0.10938-0.30859-0.10938-0.10156 0-0.19141 0.0195-0.26172 0.0508-0.0703 0.0391-0.1289 0.10938-0.17969 0.23047-0.16015 0.39844-0.26953 0.64844-0.32031 0.73828-0.0508 0.10157-0.12109 0.17969-0.1914 0.24219-0.0703 0.0586-0.16016 0.11719-0.26954 0.15625-0.0977 0.043-0.21875 0.0625-0.36718 0.0625-0.32032 0-0.5625-0.0898-0.73047-0.26953-0.17188-0.17969-0.25-0.44141-0.25-0.76953 0-0.33203 0.0781-0.58985 0.23047-0.77344 0.14843-0.17969 0.3789-0.26953 0.6875-0.26953h0.082v0.65234c-0.33203 0-0.5 0.11719-0.5 0.36719 0 0.26172 0.1289 0.39453 0.39062 0.39453 0.11719 0 0.21875-0.0312 0.27735-0.082 0.0625-0.0508 0.12109-0.14062 0.17968-0.26953l0.23047-0.51953c0.0899-0.23047 0.21094-0.39063 0.35157-0.49219 0.14062-0.0977 0.32031-0.14844 0.53906-0.14844 0.6914 0 1.0312 0.39063 1.0312 1.168zm-0.0625 1.2695v1.918h-3.3594v-1.8789h0.55078v1.1992h0.78907v-1.1289h0.55078v1.1289h0.89843v-1.25h0.55079zm-4.0586-2.3711v4.2226c0 0.76953 0.62891 1.4062 1.4102 1.4062h3.3594v-7.0273h-3.3594c-0.76953 0-1.4102 0.62891-1.4102 1.4102"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m13.523 33.309 0.22656 0.10157 0.19141-0.0664c0.125-0.0977 0.14063-0.27344 0.0391-0.39453l-0.0976-0.10547c0.10937-0.0547 0.23047-0.082 0.35547-0.082 0.24218 0 0.46875 0.0976 0.61718 0.26953 0.28125 0.32031 0.23438 0.79687-0.10156 1.0625-0.14453 0.10937-0.32422 0.17187-0.51172 0.17187-0.23828 0-0.46484-0.0976-0.61328-0.27343-0.1875-0.20703-0.22656-0.48047-0.14062-0.72266zm-1.1289-1.2812 0.68359 0.77735c-0.12109 0.17187-0.19922 0.37109-0.22266 0.58593-0.0351 0.35157 0.0781 0.69141 0.31641 0.96094 0.26562 0.30078 0.65625 0.47266 1.0703 0.47266 0.32422 0 0.64063-0.10547 0.88672-0.30078 0.58984-0.46094 0.67578-1.293 0.18359-1.8477-0.26562-0.30078-0.65625-0.47656-1.0703-0.47656-0.26562 0-0.51953 0.0742-0.74219 0.20703l-0.6875-0.78516 0.0117 4e-3 0.1211-0.0234 0.0508-0.0351 0.0664 4e-3 2.8984 0.29297c0.22266 0.0234 0.55078 0.19141 0.69141 0.35156l5.7852 6.5781c0.0859 0.0976 0.0703 0.24609-0.0352 0.32812l-3.8281 2.9961-0.15625 0.0508-0.1914-0.082-5.7852-6.5781c-0.14062-0.16015-0.25781-0.5-0.24219-0.70703l0.1875-2.6992zm10.496 6.4102-5.7812-6.582c-0.23828-0.26953-0.71484-0.50781-1.082-0.54688l-2.9024-0.29297-0.13671-8e-3 -0.89063-1.8516c-0.0664-0.13672-0.24609-0.20313-0.39062-0.13672l-0.15625 0.15625 8e-3 0.21094 0.8164 1.6953-0.0312 0.0117-1.1562-1.3203c-0.10156-0.11328-0.29687-0.13282-0.41796-0.0352-0.125 0.0977-0.14454 0.27344-0.0391 0.39453l1.2031 1.3633c-0.082 0.17969-0.12891 0.39063-0.14063 0.56641l-0.18359 2.6992c-0.0234 0.34765 0.14062 0.83203 0.375 1.1016l5.7852 6.5781c0.16015 0.18359 0.39453 0.28515 0.64843 0.28515 0.19141 0 0.38282-0.0625 0.53125-0.17969l3.832-2.9961c0.17188-0.13672 0.28125-0.32422 0.30079-0.53516 0.0195-0.21093-0.0469-0.41796-0.19141-0.57812",
    fill: "#171716"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextile);
export default __webpack_public_path__ + "static/media/textile.8ae8e623c868f3151b0728877f5cc28b.svg";
export { ForwardRef as ReactComponent };